// export const Markets=[
//   "Collective",
//   "GTAM",
//   "TAM",
// ]

// export const Exchange=[
//   "HPX",
//   "IEX",
//   "PXIL",
//   "Traders"
// ]

// export const Products=[
//   "DAM",
//   "RTM",
//   "GDAM",
//   "Intra-Day Contracts",
//   "Day Ahead Contingency Contracts",
//   "Daily Contracts",
//   "Weekly Contracts",
//   "Monthly Contracts",
//   "Any Day Contracts",
//   "Any Day Single Sided Contracts",
// ]

export const Filters = {
  filters: {
    HPX: {
      Collective: ["DAM", "RTM", "GDAM"],
      GTAM: [
        "Intra-Day Contracts",
        "Day Ahead Contingency Contracts",
        "Daily Contracts",
        "Weekly Contracts",
        "Monthly Contracts",
        "Any Day Single Sided Contracts",
      ],
      TAM: [
        "Intra-Day Contracts",
        "Day Ahead Contingency Contracts",
        "Daily Contracts",
        "Weekly Contracts",
        "Monthly Contracts",
        "Any Day Single Sided Contracts",
      ],
    },
    IEX: {
      Collective: ["DAM", "RTM", "GDAM"],
      GTAM: [
        "Intra-Day Contracts",
        "Day Ahead Contingency Contracts",
        "Daily Contracts",
        "Weekly Contracts",
        "Monthly Contracts",
        "Any Day Single Sided Contracts",
      ],
      TAM: [
        "Intra-Day Contracts",
        "Day Ahead Contingency Contracts",
        "Daily Contracts",
        "Weekly Contracts",
        "Monthly Contracts",
        "Any Day Single Sided Contracts",
      ],
    },
    PXIL: {
      Collective: ["DAM", "RTM", "GDAM"],
      GTAM: [
        "Intra-Day Contracts",
        "Day Ahead Contingency Contracts",
        "Daily Contracts",
        "Weekly Contracts",
        "Monthly Contracts",
        // "Any Day Contracts",
        "Any Day Single Sided Contracts",
      ],
      TAM: [
        "Intra-Day Contracts",
        "Day Ahead Contingency Contracts",
        "Daily Contracts",
        "Weekly Contracts",
        "Monthly Contracts",
        // "Any Day Contracts",
        "Any Day Single Sided Contracts",
      ],
    },
    Traders: { Traders: ["Bilateral"] },
  },
  months: [
    "Jan-17",
    "Feb-17",
    "Mar-17",
    "Apr-17",
    "May-17",
    "Jun-17",
    "Jul-17",
    "Aug-17",
    "Sep-17",
    "Oct-17",
    "Nov-17",
    "Dec-17",
    "Jan-18",
    "Feb-18",
    "Mar-18",
    "Apr-18",
    "May-18",
    "Jun-18",
    "Jul-18",
    "Aug-18",
    "Sep-18",
    "Oct-18",
    "Nov-18",
    "Dec-18",
    "Jan-19",
    "Feb-19",
    "Mar-19",
    "Apr-19",
    "May-19",
    "Jun-19",
    "Jul-19",
    "Aug-19",
    "Sep-19",
    "Oct-19",
    "Nov-19",
    "Dec-19",
    "Jan-20",
    "Feb-20",
    "Mar-20",
    "Apr-20",
    "May-20",
    "Jun-20",
    "Jul-20",
    "Aug-20",
    "Sep-20",
    "Oct-20",
    "Nov-20",
    "Dec-20",
    "Jan-21",
    "Feb-21",
    "Mar-21",
    "Apr-21",
    "May-21",
    "Jun-21",
    "Jul-21",
    "Aug-21",
    "Sep-21",
    "Oct-21",
    "Nov-21",
    "Dec-21",
    "Jan-22",
    "Feb-22",
    "Mar-22",
    "Apr-22",
    "May-22",
    "Jun-22",
    "Jul-22",
    "Aug-22",
    "Sep-22",
    "Oct-22",
    "Nov-22",
    "Dec-22",
    "Jan-23",
    "Feb-23",
    "Mar-23",
    "Apr-23",
    "May-23",
    "Jun-23",
    "Jul-23",
    "Aug-23",
    "Sep-23",
  ],
};

export interface Product {
  id: number;
  name: string;
}

export interface Filter {
  id: number;
  name: string;
  products: Product[];
}

const TamProducts: Product[] = [
  {
    id: 4,
    name: "Intra-Day Contracts",
  },
  {
    id: 5,
    name: "Day Ahead Contingency Contracts",
  },
  {
    id: 6,
    name: "Daily Contracts",
  },
  {
    id: 7,
    name: "Weekly Contracts",
  },
  {
    id: 8,
    name: "Monthly Contracts",
  },
  // {
  //   id: 9,
  //   name: "Any Day Contracts",
  // },
  {
    id: 10,
    name: "Any Day Single Sided Contracts",
  },
  // {
  //   id: 11,
  //   name: "Trading Licenses",
  // },
];

export const Markets: Filter[] = [
  {
    id: 1,
    name: "Collective",
    products: [
      {id: 1, name: "DAM" },
      {id: 2, name: "RTM"},
      {id: 3, name: "GDAM"},
      {id: 12, name: "HPDAM"},

    ],
  },
  {
    id: 2,
    name: "GTAM",
    products: TamProducts,
  },
  {
    id: 3,
    name: "TAM",
    products: TamProducts,
  },
];

export const Exchange: Filter[] = [
  {
    id: 2,
    name: "IEX",
    products: [
      { id: 1, name: "DAM" },
      { id: 2, name: "RTM" },
      { id: 3, name: "GDAM" },
      {id: 12, name: "HPDAM"},
      { id: 4, name: "Intra-Day Contracts" },
      { id: 5, name: "Day Ahead Contingency Contracts" },
      { id: 6, name: "Daily Contracts" },
      { id: 7, name: "Weekly Contracts" },
      { id: 8, name: "Monthly Contracts" },
      { id: 10, name: "Any Day Single Sided Contracts" },
    ],
  },
  {
    id: 1,
    name: "HPX",
    products: [
      { id: 1, name: "DAM" },
      { id: 2, name: "RTM" },
      { id: 3, name: "GDAM" },
      { id: 4, name: "Intra-Day Contracts" },
      { id: 5, name: "Day Ahead Contingency Contracts" },
      { id: 6, name: "Daily Contracts" },
      { id: 7, name: "Weekly Contracts" },
      { id: 8, name: "Monthly Contracts" },
      { id: 10, name: "Any Day Single Sided Contracts" },
    ],
  },
  {
    id: 3,
    name: "PXIL",
    products: [
      { id: 1, name: "DAM" },
      { id: 2, name: "RTM" },
      { id: 3, name: "GDAM" },
      {id: 12, name: "HPDAM"},

      { id: 4, name: "Intra-Day Contracts" },
      { id: 5, name: "Day Ahead Contingency Contracts" },
      { id: 6, name: "Daily Contracts" },
      { id: 7, name: "Weekly Contracts" },
      { id: 8, name: "Monthly Contracts" },
      // { id: 9, name: "Any Day Contracts" },
      { id: 10, name: "Any Day Single Sided Contracts" },
    ],
  },
  {
    id: 4,
    name: "Traders",
    products: [{ id: 11, name: "Trading License" }],
  },
];
export const Months = [
  "Jan-17",
  "Feb-17",
  "Mar-17",
  "Apr-17",
  "May-17",
  "Jun-17",
  "Jul-17",
  "Aug-17",
  "Sep-17",
  "Oct-17",
  "Nov-17",
  "Dec-17",
  "Jan-18",
  "Feb-18",
  "Mar-18",
  "Apr-18",
  "May-18",
  "Jun-18",
  "Jul-18",
  "Aug-18",
  "Sep-18",
  "Oct-18",
  "Nov-18",
  "Dec-18",
  "Jan-19",
  "Feb-19",
  "Mar-19",
  "Apr-19",
  "May-19",
  "Jun-19",
  "Jul-19",
  "Aug-19",
  "Sep-19",
  "Oct-19",
  "Nov-19",
  "Dec-19",
  "Jan-20",
  "Feb-20",
  "Mar-20",
  "Apr-20",
  "May-20",
  "Jun-20",
  "Jul-20",
  "Aug-20",
  "Sep-20",
  "Oct-20",
  "Nov-20",
  "Dec-20",
  "Jan-21",
  "Feb-21",
  "Mar-21",
  "Apr-21",
  "May-21",
  "Jun-21",
  "Jul-21",
  "Aug-21",
  "Sep-21",
  "Oct-21",
  "Nov-21",
  "Dec-21",
  "Jan-22",
  "Feb-22",
  "Mar-22",
  "Apr-22",
  "May-22",
  "Jun-22",
  "Jul-22",
  "Aug-22",
  "Sep-22",
  "Oct-22",
  "Nov-22",
  "Dec-22",
  "Jan-23",
  "Feb-23",
  "Mar-23",
  "Apr-23",
  "May-23",
  "Jun-23",
  "Jul-23",
  "Aug-23",
  "Sep-23",
];

export const DemoExchangeData = {
  HPX: {
    Collective: [
      {
        month: "Jan-17",
        product: "DAM",
        value: 0,
      },
      {
        month: "Feb-17",
        product: "DAM",
        value: 0,
      },
      {
        month: "Mar-17",
        product: "DAM",
        value: 0,
      },
      {
        month: "Apr-17",
        product: "DAM",
        value: 0,
      },
      {
        month: "May-17",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jun-17",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jul-17",
        product: "DAM",
        value: 0,
      },
      {
        month: "Aug-17",
        product: "DAM",
        value: 0,
      },
      {
        month: "Sep-17",
        product: "DAM",
        value: 0,
      },
      {
        month: "Oct-17",
        product: "DAM",
        value: 0,
      },
      {
        month: "Nov-17",
        product: "DAM",
        value: 0,
      },
      {
        month: "Dec-17",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jan-18",
        product: "DAM",
        value: 0,
      },
      {
        month: "Feb-18",
        product: "DAM",
        value: 0,
      },
      {
        month: "Mar-18",
        product: "DAM",
        value: 0,
      },
      {
        month: "Apr-18",
        product: "DAM",
        value: 0,
      },
      {
        month: "May-18",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jun-18",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jul-18",
        product: "DAM",
        value: 0,
      },
      {
        month: "Aug-18",
        product: "DAM",
        value: 0,
      },
      {
        month: "Sep-18",
        product: "DAM",
        value: 0,
      },
      {
        month: "Oct-18",
        product: "DAM",
        value: 0,
      },
      {
        month: "Nov-18",
        product: "DAM",
        value: 0,
      },
      {
        month: "Dec-18",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jan-19",
        product: "DAM",
        value: 0,
      },
      {
        month: "Feb-19",
        product: "DAM",
        value: 0,
      },
      {
        month: "Mar-19",
        product: "DAM",
        value: 0,
      },
      {
        month: "Apr-19",
        product: "DAM",
        value: 0,
      },
      {
        month: "May-19",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jun-19",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jul-19",
        product: "DAM",
        value: 0,
      },
      {
        month: "Aug-19",
        product: "DAM",
        value: 0,
      },
      {
        month: "Sep-19",
        product: "DAM",
        value: 0,
      },
      {
        month: "Oct-19",
        product: "DAM",
        value: 0,
      },
      {
        month: "Nov-19",
        product: "DAM",
        value: 0,
      },
      {
        month: "Dec-19",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jan-20",
        product: "DAM",
        value: 0,
      },
      {
        month: "Feb-20",
        product: "DAM",
        value: 0,
      },
      {
        month: "Mar-20",
        product: "DAM",
        value: 0,
      },
      {
        month: "Apr-20",
        product: "DAM",
        value: 0,
      },
      {
        month: "May-20",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jun-20",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jul-20",
        product: "DAM",
        value: 0,
      },
      {
        month: "Aug-20",
        product: "DAM",
        value: 0,
      },
      {
        month: "Sep-20",
        product: "DAM",
        value: 0,
      },
      {
        month: "Oct-20",
        product: "DAM",
        value: 0,
      },
      {
        month: "Nov-20",
        product: "DAM",
        value: 0,
      },
      {
        month: "Dec-20",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jan-21",
        product: "DAM",
        value: 0,
      },
      {
        month: "Feb-21",
        product: "DAM",
        value: 0,
      },
      {
        month: "Mar-21",
        product: "DAM",
        value: 0,
      },
      {
        month: "Apr-21",
        product: "DAM",
        value: 0,
      },
      {
        month: "May-21",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jun-21",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jul-21",
        product: "DAM",
        value: 0,
      },
      {
        month: "Aug-21",
        product: "DAM",
        value: 0,
      },
      {
        month: "Sep-21",
        product: "DAM",
        value: 0,
      },
      {
        month: "Oct-21",
        product: "DAM",
        value: 0,
      },
      {
        month: "Nov-21",
        product: "DAM",
        value: 0,
      },
      {
        month: "Dec-21",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jan-22",
        product: "DAM",
        value: 0,
      },
      {
        month: "Feb-22",
        product: "DAM",
        value: 0,
      },
      {
        month: "Mar-22",
        product: "DAM",
        value: 0,
      },
      {
        month: "Apr-22",
        product: "DAM",
        value: 0,
      },
      {
        month: "May-22",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jun-22",
        product: "DAM",
        value: 0,
      },
      {
        month: "Jul-22",
        product: "DAM",
        value: 1.43,
      },
      {
        month: "Aug-22",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "DAM",
        value: 0.27,
      },
      {
        month: "Sep-23",
        product: "DAM",
        value: 18.51,
      },
      {
        month: "Jan-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Feb-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Mar-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Apr-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "May-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jun-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jul-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Aug-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Sep-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Oct-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Nov-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Dec-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jan-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Feb-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Mar-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Apr-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "May-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jun-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jul-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Aug-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Sep-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Oct-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Nov-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Dec-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jan-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Feb-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Mar-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Apr-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "May-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jun-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jul-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Aug-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Sep-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Oct-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Nov-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Dec-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jan-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Feb-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Mar-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Apr-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "May-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jun-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jul-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Aug-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Sep-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Oct-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Nov-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Dec-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jan-21",
        product: "RTM",
        value: 0,
      },
      {
        month: "Feb-21",
        product: "RTM",
        value: 0,
      },
      {
        month: "Mar-21",
        product: "RTM",
        value: 0,
      },
      {
        month: "Apr-21",
        product: "RTM",
        value: 0,
      },
      {
        month: "May-21",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jun-21",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jul-21",
        product: "RTM",
        value: 0,
      },
      {
        month: "Aug-21",
        product: "RTM",
        value: 0,
      },
      {
        month: "Sep-21",
        product: "RTM",
        value: 0,
      },
      {
        month: "Oct-21",
        product: "RTM",
        value: 0,
      },
      {
        month: "Nov-21",
        product: "RTM",
        value: 0,
      },
      {
        month: "Dec-21",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jan-22",
        product: "RTM",
        value: 0,
      },
      {
        month: "Feb-22",
        product: "RTM",
        value: 0,
      },
      {
        month: "Mar-22",
        product: "RTM",
        value: 0,
      },
      {
        month: "Apr-22",
        product: "RTM",
        value: 0,
      },
      {
        month: "May-22",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jun-22",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jul-22",
        product: "RTM",
        value: 0,
      },
      {
        month: "Aug-22",
        product: "RTM",
        value: 0,
      },
      {
        month: "Sep-22",
        product: "RTM",
        value: 0,
      },
      {
        month: "Oct-22",
        product: "RTM",
        value: 0,
      },
      {
        month: "Nov-22",
        product: "RTM",
        value: 0,
      },
      {
        month: "Dec-22",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jan-23",
        product: "RTM",
        value: 0,
      },
      {
        month: "Feb-23",
        product: "RTM",
        value: 0,
      },
      {
        month: "Mar-23",
        product: "RTM",
        value: 0,
      },
      {
        month: "Apr-23",
        product: "RTM",
        value: 0.10619999999999997,
      },
      {
        month: "May-23",
        product: "RTM",
        value: 1.7245,
      },
      {
        month: "Jun-23",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jul-23",
        product: "RTM",
        value: 0,
      },
      {
        month: "Aug-23",
        product: "RTM",
        value: 0,
      },
      {
        month: "Sep-23",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jan-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Aug-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Sep-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Oct-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Nov-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Dec-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jan-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Aug-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Sep-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Oct-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Nov-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Dec-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jan-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Aug-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Sep-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Oct-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Nov-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Dec-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jan-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Aug-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Sep-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Oct-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Nov-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Dec-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jan-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Aug-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Sep-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Oct-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Nov-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Dec-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jan-22",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-22",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-22",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-22",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-22",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-22",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "GDAM",
        value: 0.0,
      },
    ],
    GTAM: [
      {
        month: "Jan-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Intra-Day Contracts",
        value: 0.04,
      },
      {
        month: "Sep-23",
        product: "Intra-Day Contracts",
        value: 0.1,
      },
      {
        month: "Jan-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Day Ahead Contingency Contracts",
        value: 16.69,
      },
      {
        month: "Jan-23",
        product: "Day Ahead Contingency Contracts",
        value: 18.60662500000047,
      },
      {
        month: "Feb-23",
        product: "Day Ahead Contingency Contracts",
        value: 22.88870000000023,
      },
      {
        month: "Mar-23",
        product: "Day Ahead Contingency Contracts",
        value: 1.1265000000000007,
      },
      {
        month: "Apr-23",
        product: "Day Ahead Contingency Contracts",
        value: 7.654285000000092,
      },
      {
        month: "May-23",
        product: "Day Ahead Contingency Contracts",
        value: 19.458774999999815,
      },
      {
        month: "Jun-23",
        product: "Day Ahead Contingency Contracts",
        value: 52.07500599999992,
      },
      {
        month: "Jul-23",
        product: "Day Ahead Contingency Contracts",
        value: 74.6347830000005,
      },
      {
        month: "Aug-23",
        product: "Day Ahead Contingency Contracts",
        value: 78.82959400000041,
      },
      {
        month: "Sep-23",
        product: "Day Ahead Contingency Contracts",
        value: 59.97424599999994,
      },
      {
        month: "Jan-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Any Day Single Sided Contracts",
        value: 7.44,
      },
      {
        month: "Apr-23",
        product: "Any Day Single Sided Contracts",
        value: 8.64,
      },
      {
        month: "May-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Any Day Single Sided Contracts",
        value: 1.2528000000000001,
      },
      {
        month: "Aug-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
    ],
    TAM: [
      {
        month: "Jan-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Intra-Day Contracts",
        value: 1.01,
      },
      {
        month: "Aug-22",
        product: "Intra-Day Contracts",
        value: 0.63,
      },
      {
        month: "Sep-22",
        product: "Intra-Day Contracts",
        value: 0.12,
      },
      {
        month: "Oct-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Intra-Day Contracts",
        value: 0.21,
      },
      {
        month: "Dec-22",
        product: "Intra-Day Contracts",
        value: 0.56,
      },
      {
        month: "Jan-23",
        product: "Intra-Day Contracts",
        value: 1.4040000000000001,
      },
      {
        month: "Feb-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Intra-Day Contracts",
        value: 0.8290000000000003,
      },
      {
        month: "Apr-23",
        product: "Intra-Day Contracts",
        value: 6.43150000000001,
      },
      {
        month: "May-23",
        product: "Intra-Day Contracts",
        value: 6.403600000000027,
      },
      {
        month: "Jun-23",
        product: "Intra-Day Contracts",
        value: 12.081750000000016,
      },
      {
        month: "Jul-23",
        product: "Intra-Day Contracts",
        value: 4.74849999999999,
      },
      {
        month: "Aug-23",
        product: "Intra-Day Contracts",
        value: 10.057499999999992,
      },
      {
        month: "Sep-23",
        product: "Intra-Day Contracts",
        value: 4.696000000000015,
      },
      {
        month: "Jan-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Day Ahead Contingency Contracts",
        value: 220.95,
      },
      {
        month: "Aug-22",
        product: "Day Ahead Contingency Contracts",
        value: 259.23,
      },
      {
        month: "Sep-22",
        product: "Day Ahead Contingency Contracts",
        value: 106.83,
      },
      {
        month: "Oct-22",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Day Ahead Contingency Contracts",
        value: 104.82,
      },
      {
        month: "Dec-22",
        product: "Day Ahead Contingency Contracts",
        value: 186.67,
      },
      {
        month: "Jan-23",
        product: "Day Ahead Contingency Contracts",
        value: 358.49435250001096,
      },
      {
        month: "Feb-23",
        product: "Day Ahead Contingency Contracts",
        value: 545.9820211182472,
      },
      {
        month: "Mar-23",
        product: "Day Ahead Contingency Contracts",
        value: 466.626102499989,
      },
      {
        month: "Apr-23",
        product: "Day Ahead Contingency Contracts",
        value: 508.40713049998095,
      },
      {
        month: "May-23",
        product: "Day Ahead Contingency Contracts",
        value: 445.88281599999533,
      },
      {
        month: "Jun-23",
        product: "Day Ahead Contingency Contracts",
        value: 651.5697559999667,
      },
      {
        month: "Jul-23",
        product: "Day Ahead Contingency Contracts",
        value: 634.267957999992,
      },
      {
        month: "Aug-23",
        product: "Day Ahead Contingency Contracts",
        value: 1012.9013809999805,
      },
      {
        month: "Sep-23",
        product: "Day Ahead Contingency Contracts",
        value: 571.0422480000033,
      },
      {
        month: "Jan-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Daily Contracts",
        value: 9.6,
      },
      {
        month: "Jan-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Daily Contracts",
        value: 4.8784,
      },
      {
        month: "Apr-23",
        product: "Daily Contracts",
        value: 22.6123348,
      },
      {
        month: "May-23",
        product: "Daily Contracts",
        value: 144.85016799999966,
      },
      {
        month: "Jun-23",
        product: "Daily Contracts",
        value: 11.723099999999986,
      },
      {
        month: "Jul-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Daily Contracts",
        value: 113.43999999999954,
      },
      {
        month: "Sep-23",
        product: "Daily Contracts",
        value: 94.00000000000065,
      },
      {
        month: "Jan-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Weekly Contracts",
        value: 50.4,
      },
      {
        month: "Dec-22",
        product: "Weekly Contracts",
        value: 36.12,
      },
      {
        month: "Jan-23",
        product: "Weekly Contracts",
        value: 50.400000000000006,
      },
      {
        month: "Feb-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Weekly Contracts",
        value: 42.0,
      },
      {
        month: "May-23",
        product: "Weekly Contracts",
        value: 42.0,
      },
      {
        month: "Jun-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Monthly Contracts",
        value: 148.79999999999998,
      },
      {
        month: "Apr-23",
        product: "Monthly Contracts",
        value: 192.24,
      },
      {
        month: "May-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Any Day Single Sided Contracts",
        value: 19.872000000000003,
      },
      {
        month: "Mar-23",
        product: "Any Day Single Sided Contracts",
        value: 44.745580000000025,
      },
      {
        month: "Apr-23",
        product: "Any Day Single Sided Contracts",
        value: 64.97712,
      },
      {
        month: "May-23",
        product: "Any Day Single Sided Contracts",
        value: 15.208,
      },
      {
        month: "Jun-23",
        product: "Any Day Single Sided Contracts",
        value: 83.52,
      },
      {
        month: "Jul-23",
        product: "Any Day Single Sided Contracts",
        value: 154.01661000000004,
      },
      {
        month: "Aug-23",
        product: "Any Day Single Sided Contracts",
        value: 241.90071800000007,
      },
      {
        month: "Sep-23",
        product: "Any Day Single Sided Contracts",
        value: 423.987228,
      },
    ],
  },
  IEX: {
    Collective: [
      {
        month: "Jan-17",
        product: "DAM",
        value: 3230.61,
      },
      {
        month: "Feb-17",
        product: "DAM",
        value: 2926.89,
      },
      {
        month: "Mar-17",
        product: "DAM",
        value: 3364.41,
      },
      {
        month: "Apr-17",
        product: "DAM",
        value: 3716.96,
      },
      {
        month: "May-17",
        product: "DAM",
        value: 4100.01,
      },
      {
        month: "Jun-17",
        product: "DAM",
        value: 3920.07,
      },
      {
        month: "Jul-17",
        product: "DAM",
        value: 3668.77,
      },
      {
        month: "Aug-17",
        product: "DAM",
        value: 3982.18,
      },
      {
        month: "Sep-17",
        product: "DAM",
        value: 4086.6,
      },
      {
        month: "Oct-17",
        product: "DAM",
        value: 4078.61,
      },
      {
        month: "Nov-17",
        product: "DAM",
        value: 3524.43,
      },
      {
        month: "Dec-17",
        product: "DAM",
        value: 3107.74,
      },
      {
        month: "Jan-18",
        product: "DAM",
        value: 3375.23,
      },
      {
        month: "Feb-18",
        product: "DAM",
        value: 3325.97,
      },
      {
        month: "Mar-18",
        product: "DAM",
        value: 3955.29,
      },
      {
        month: "Apr-18",
        product: "DAM",
        value: 4055.25,
      },
      {
        month: "May-18",
        product: "DAM",
        value: 4915.98,
      },
      {
        month: "Jun-18",
        product: "DAM",
        value: 4965.17,
      },
      {
        month: "Jul-18",
        product: "DAM",
        value: 4027.79,
      },
      {
        month: "Aug-18",
        product: "DAM",
        value: 3974.69,
      },
      {
        month: "Sep-18",
        product: "DAM",
        value: 5724.63,
      },
      {
        month: "Oct-18",
        product: "DAM",
        value: 6504.22,
      },
      {
        month: "Nov-18",
        product: "DAM",
        value: 3403.89,
      },
      {
        month: "Dec-18",
        product: "DAM",
        value: 3058.7,
      },
      {
        month: "Jan-19",
        product: "DAM",
        value: 3280.86,
      },
      {
        month: "Feb-19",
        product: "DAM",
        value: 2794.09,
      },
      {
        month: "Mar-19",
        product: "DAM",
        value: 3356.08,
      },
      {
        month: "Apr-19",
        product: "DAM",
        value: 4005.41,
      },
      {
        month: "May-19",
        product: "DAM",
        value: 3772.47,
      },
      {
        month: "Jun-19",
        product: "DAM",
        value: 4206.68,
      },
      {
        month: "Jul-19",
        product: "DAM",
        value: 4800.37,
      },
      {
        month: "Aug-19",
        product: "DAM",
        value: 4674.88462,
      },
      {
        month: "Sep-19",
        product: "DAM",
        value: 3487.57,
      },
      {
        month: "Oct-19",
        product: "DAM",
        value: 3391.49,
      },
      {
        month: "Nov-19",
        product: "DAM",
        value: 3388.84,
      },
      {
        month: "Dec-19",
        product: "DAM",
        value: 4333.32,
      },
      {
        month: "Jan-20",
        product: "DAM",
        value: 4790.79,
      },
      {
        month: "Feb-20",
        product: "DAM",
        value: 4289.15,
      },
      {
        month: "Mar-20",
        product: "DAM",
        value: 3971.24,
      },
      {
        month: "Apr-20",
        product: "DAM",
        value: 3692.04,
      },
      {
        month: "May-20",
        product: "DAM",
        value: 5573.73,
      },
      {
        month: "Jun-20",
        product: "DAM",
        value: 4174.34,
      },
      {
        month: "Jul-20",
        product: "DAM",
        value: 4486.7,
      },
      {
        month: "Aug-20",
        product: "DAM",
        value: 4484.36,
      },
      {
        month: "Sep-20",
        product: "DAM",
        value: 4780.99,
      },
      {
        month: "Oct-20",
        product: "DAM",
        value: 5500.53,
      },
      {
        month: "Nov-20",
        product: "DAM",
        value: 4860.46,
      },
      {
        month: "Dec-20",
        product: "DAM",
        value: 5605.58,
      },
      {
        month: "Jan-21",
        product: "DAM",
        value: 5568.6,
      },
      {
        month: "Feb-21",
        product: "DAM",
        value: 5099.75,
      },
      {
        month: "Mar-21",
        product: "DAM",
        value: 6548.94,
      },
      {
        month: "Apr-21",
        product: "DAM",
        value: 5699.22,
      },
      {
        month: "May-21",
        product: "DAM",
        value: 4363.88,
      },
      {
        month: "Jun-21",
        product: "DAM",
        value: 4314.17,
      },
      {
        month: "Jul-21",
        product: "DAM",
        value: 4238.25,
      },
      {
        month: "Aug-21",
        product: "DAM",
        value: 6648.76,
      },
      {
        month: "Sep-21",
        product: "DAM",
        value: 6418.26,
      },
      {
        month: "Oct-21",
        product: "DAM",
        value: 6568.31,
      },
      {
        month: "Nov-21",
        product: "DAM",
        value: 4718.76,
      },
      {
        month: "Dec-21",
        product: "DAM",
        value: 5423.27,
      },
      {
        month: "Jan-22",
        product: "DAM",
        value: 5279.69,
      },
      {
        month: "Feb-22",
        product: "DAM",
        value: 5612.07,
      },
      {
        month: "Mar-22",
        product: "DAM",
        value: 5858.39,
      },
      {
        month: "Apr-22",
        product: "DAM",
        value: 4113.65,
      },
      {
        month: "May-22",
        product: "DAM",
        value: 3172.5,
      },
      {
        month: "Jun-22",
        product: "DAM",
        value: 4084.99,
      },
      {
        month: "Jul-22",
        product: "DAM",
        value: 3516.65,
      },
      {
        month: "Aug-22",
        product: "DAM",
        value: 3528.7,
      },
      {
        month: "Sep-22",
        product: "DAM",
        value: 4049.64,
      },
      {
        month: "Oct-22",
        product: "DAM",
        value: 4325.01,
      },
      {
        month: "Nov-22",
        product: "DAM",
        value: 5083.85,
      },
      {
        month: "Dec-22",
        product: "DAM",
        value: 4977.44,
      },
      {
        month: "Jan-23",
        product: "DAM",
        value: 4947.96,
      },
      {
        month: "Feb-23",
        product: "DAM",
        value: 4658.76,
      },
      {
        month: "Mar-23",
        product: "DAM",
        value: 4718.38,
      },
      {
        month: "Apr-23",
        product: "DAM",
        value: 4408.93,
      },
      {
        month: "May-23",
        product: "DAM",
        value: 3999.76,
      },
      {
        month: "Jun-23",
        product: "DAM",
        value: 4123.34,
      },
      {
        month: "Jul-23",
        product: "DAM",
        value: 3966.2,
      },
      {
        month: "Aug-23",
        product: "DAM",
        value: 3881.41,
      },
      {
        month: "Sep-23",
        product: "DAM",
        value: 3405.42,
      },
      {
        month: "Jan-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Feb-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Mar-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Apr-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "May-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jun-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jul-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Aug-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Sep-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Oct-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Nov-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Dec-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jan-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Feb-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Mar-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Apr-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "May-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jun-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jul-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Aug-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Sep-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Oct-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Nov-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Dec-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jan-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Feb-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Mar-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Apr-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "May-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jun-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jul-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Aug-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Sep-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Oct-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Nov-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Dec-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jan-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Feb-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Mar-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Apr-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "May-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jun-20",
        product: "RTM",
        value: 515.46,
      },
      {
        month: "Jul-20",
        product: "RTM",
        value: 784.94,
      },
      {
        month: "Aug-20",
        product: "RTM",
        value: 860.57,
      },
      {
        month: "Sep-20",
        product: "RTM",
        value: 704.04,
      },
      {
        month: "Oct-20",
        product: "RTM",
        value: 814.48,
      },
      {
        month: "Nov-20",
        product: "RTM",
        value: 893.62,
      },
      {
        month: "Dec-20",
        product: "RTM",
        value: 1129.09,
      },
      {
        month: "Jan-21",
        product: "RTM",
        value: 1233.31,
      },
      {
        month: "Feb-21",
        product: "RTM",
        value: 1118.45,
      },
      {
        month: "Mar-21",
        product: "RTM",
        value: 1413.96,
      },
      {
        month: "Apr-21",
        product: "RTM",
        value: 1473.36,
      },
      {
        month: "May-21",
        product: "RTM",
        value: 1436.28,
      },
      {
        month: "Jun-21",
        product: "RTM",
        value: 1725.7,
      },
      {
        month: "Jul-21",
        product: "RTM",
        value: 1596.0,
      },
      {
        month: "Aug-21",
        product: "RTM",
        value: 1859.46,
      },
      {
        month: "Sep-21",
        product: "RTM",
        value: 1842.59,
      },
      {
        month: "Oct-21",
        product: "RTM",
        value: 1999.17,
      },
      {
        month: "Nov-21",
        product: "RTM",
        value: 1311.35,
      },
      {
        month: "Dec-21",
        product: "RTM",
        value: 1512.39,
      },
      {
        month: "Jan-22",
        product: "RTM",
        value: 1575.13,
      },
      {
        month: "Feb-22",
        product: "RTM",
        value: 1555.78,
      },
      {
        month: "Mar-22",
        product: "RTM",
        value: 2020.86,
      },
      {
        month: "Apr-22",
        product: "RTM",
        value: 1704.28,
      },
      {
        month: "May-22",
        product: "RTM",
        value: 2318.72,
      },
      {
        month: "Jun-22",
        product: "RTM",
        value: 2213.66,
      },
      {
        month: "Jul-22",
        product: "RTM",
        value: 2130.98,
      },
      {
        month: "Aug-22",
        product: "RTM",
        value: 2265.25,
      },
      {
        month: "Sep-22",
        product: "RTM",
        value: 2192.7,
      },
      {
        month: "Oct-22",
        product: "RTM",
        value: 2264.59,
      },
      {
        month: "Nov-22",
        product: "RTM",
        value: 1406.84,
      },
      {
        month: "Dec-22",
        product: "RTM",
        value: 1763.05,
      },
      {
        month: "Jan-23",
        product: "RTM",
        value: 2101.88,
      },
      {
        month: "Feb-23",
        product: "RTM",
        value: 1714.05,
      },
      {
        month: "Mar-23",
        product: "RTM",
        value: 2097.72,
      },
      {
        month: "Apr-23",
        product: "RTM",
        value: 2152.45,
      },
      {
        month: "May-23",
        product: "RTM",
        value: 2424.26,
      },
      {
        month: "Jun-23",
        product: "RTM",
        value: 2675.25,
      },
      {
        month: "Jul-23",
        product: "RTM",
        value: 2540.45,
      },
      {
        month: "Aug-23",
        product: "RTM",
        value: 2738.05,
      },
      {
        month: "Sep-23",
        product: "RTM",
        value: 2922.95,
      },
      {
        month: "Jan-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Aug-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Sep-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Oct-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Nov-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Dec-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jan-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Aug-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Sep-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Oct-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Nov-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Dec-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jan-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Aug-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Sep-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Oct-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Nov-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Dec-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jan-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Aug-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Sep-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Oct-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Nov-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Dec-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jan-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Aug-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Sep-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Oct-21",
        product: "GDAM",
        value: 19.41,
      },
      {
        month: "Nov-21",
        product: "GDAM",
        value: 149.47,
      },
      {
        month: "Dec-21",
        product: "GDAM",
        value: 157.2,
      },
      {
        month: "Jan-22",
        product: "GDAM",
        value: 198.35,
      },
      {
        month: "Feb-22",
        product: "GDAM",
        value: 191.2,
      },
      {
        month: "Mar-22",
        product: "GDAM",
        value: 204.82,
      },
      {
        month: "Apr-22",
        product: "GDAM",
        value: 214.73,
      },
      {
        month: "May-22",
        product: "GDAM",
        value: 493.17,
      },
      {
        month: "Jun-22",
        product: "GDAM",
        value: 362.23,
      },
      {
        month: "Jul-22",
        product: "GDAM",
        value: 446.42,
      },
      {
        month: "Aug-22",
        product: "GDAM",
        value: 320.5,
      },
      {
        month: "Sep-22",
        product: "GDAM",
        value: 324.39,
      },
      {
        month: "Oct-22",
        product: "GDAM",
        value: 292.93,
      },
      {
        month: "Nov-22",
        product: "GDAM",
        value: 288.32,
      },
      {
        month: "Dec-22",
        product: "GDAM",
        value: 237.98,
      },
      {
        month: "Jan-23",
        product: "GDAM",
        value: 285.15,
      },
      {
        month: "Feb-23",
        product: "GDAM",
        value: 253.0,
      },
      {
        month: "Mar-23",
        product: "GDAM",
        value: 297.75,
      },
      {
        month: "Apr-23",
        product: "GDAM",
        value: 157.55,
      },
      {
        month: "May-23",
        product: "GDAM",
        value: 198.12,
      },
      {
        month: "Jun-23",
        product: "GDAM",
        value: 167.36,
      },
      {
        month: "Jul-23",
        product: "GDAM",
        value: 212.14,
      },
      {
        month: "Aug-23",
        product: "GDAM",
        value: 162.71,
      },
      {
        month: "Sep-23",
        product: "GDAM",
        value: 134.92,
      },
    ],
    GTAM: [
      {
        month: "Jan-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Intra-Day Contracts",
        value: 0.002,
      },
      {
        month: "Sep-20",
        product: "Intra-Day Contracts",
        value: 0.8,
      },
      {
        month: "Oct-20",
        product: "Intra-Day Contracts",
        value: 5.085,
      },
      {
        month: "Nov-20",
        product: "Intra-Day Contracts",
        value: 3.13,
      },
      {
        month: "Dec-20",
        product: "Intra-Day Contracts",
        value: 0.518,
      },
      {
        month: "Jan-21",
        product: "Intra-Day Contracts",
        value: 0.375,
      },
      {
        month: "Feb-21",
        product: "Intra-Day Contracts",
        value: 1.717,
      },
      {
        month: "Mar-21",
        product: "Intra-Day Contracts",
        value: 0.35,
      },
      {
        month: "Apr-21",
        product: "Intra-Day Contracts",
        value: 3.428,
      },
      {
        month: "May-21",
        product: "Intra-Day Contracts",
        value: 12.095,
      },
      {
        month: "Jun-21",
        product: "Intra-Day Contracts",
        value: 10.17,
      },
      {
        month: "Jul-21",
        product: "Intra-Day Contracts",
        value: 8.92,
      },
      {
        month: "Aug-21",
        product: "Intra-Day Contracts",
        value: 9.3,
      },
      {
        month: "Sep-21",
        product: "Intra-Day Contracts",
        value: 6.25,
      },
      {
        month: "Oct-21",
        product: "Intra-Day Contracts",
        value: 4.68,
      },
      {
        month: "Nov-21",
        product: "Intra-Day Contracts",
        value: 1.95,
      },
      {
        month: "Dec-21",
        product: "Intra-Day Contracts",
        value: 4.33,
      },
      {
        month: "Jan-22",
        product: "Intra-Day Contracts",
        value: 1.23,
      },
      {
        month: "Feb-22",
        product: "Intra-Day Contracts",
        value: 1.41,
      },
      {
        month: "Mar-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Intra-Day Contracts",
        value: 0.2,
      },
      {
        month: "May-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Intra-Day Contracts",
        value: 1.75,
      },
      {
        month: "Aug-22",
        product: "Intra-Day Contracts",
        value: 1.2,
      },
      {
        month: "Sep-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Intra-Day Contracts",
        value: 0.05050000000000003,
      },
      {
        month: "May-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Intra-Day Contracts",
        value: 0.26000000000000006,
      },
      {
        month: "Jan-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Day Ahead Contingency Contracts",
        value: 2.66,
      },
      {
        month: "Sep-20",
        product: "Day Ahead Contingency Contracts",
        value: 71.54,
      },
      {
        month: "Oct-20",
        product: "Day Ahead Contingency Contracts",
        value: 208.35,
      },
      {
        month: "Nov-20",
        product: "Day Ahead Contingency Contracts",
        value: 159.13,
      },
      {
        month: "Dec-20",
        product: "Day Ahead Contingency Contracts",
        value: 89.65,
      },
      {
        month: "Jan-21",
        product: "Day Ahead Contingency Contracts",
        value: 71.18,
      },
      {
        month: "Feb-21",
        product: "Day Ahead Contingency Contracts",
        value: 91.03,
      },
      {
        month: "Mar-21",
        product: "Day Ahead Contingency Contracts",
        value: 53.85,
      },
      {
        month: "Apr-21",
        product: "Day Ahead Contingency Contracts",
        value: 172.01,
      },
      {
        month: "May-21",
        product: "Day Ahead Contingency Contracts",
        value: 304.55,
      },
      {
        month: "Jun-21",
        product: "Day Ahead Contingency Contracts",
        value: 369.42,
      },
      {
        month: "Jul-21",
        product: "Day Ahead Contingency Contracts",
        value: 445.84,
      },
      {
        month: "Aug-21",
        product: "Day Ahead Contingency Contracts",
        value: 359.04,
      },
      {
        month: "Sep-21",
        product: "Day Ahead Contingency Contracts",
        value: 436.02,
      },
      {
        month: "Oct-21",
        product: "Day Ahead Contingency Contracts",
        value: 336.77,
      },
      {
        month: "Nov-21",
        product: "Day Ahead Contingency Contracts",
        value: 304.76,
      },
      {
        month: "Dec-21",
        product: "Day Ahead Contingency Contracts",
        value: 208.28,
      },
      {
        month: "Jan-22",
        product: "Day Ahead Contingency Contracts",
        value: 72.57,
      },
      {
        month: "Feb-22",
        product: "Day Ahead Contingency Contracts",
        value: 236.24,
      },
      {
        month: "Mar-22",
        product: "Day Ahead Contingency Contracts",
        value: 182.42,
      },
      {
        month: "Apr-22",
        product: "Day Ahead Contingency Contracts",
        value: 88.67,
      },
      {
        month: "May-22",
        product: "Day Ahead Contingency Contracts",
        value: 91.89,
      },
      {
        month: "Jun-22",
        product: "Day Ahead Contingency Contracts",
        value: 168.76,
      },
      {
        month: "Jul-22",
        product: "Day Ahead Contingency Contracts",
        value: 140.12,
      },
      {
        month: "Aug-22",
        product: "Day Ahead Contingency Contracts",
        value: 112.47,
      },
      {
        month: "Sep-22",
        product: "Day Ahead Contingency Contracts",
        value: 125.01,
      },
      {
        month: "Oct-22",
        product: "Day Ahead Contingency Contracts",
        value: 88.45,
      },
      {
        month: "Nov-22",
        product: "Day Ahead Contingency Contracts",
        value: 63.13,
      },
      {
        month: "Dec-22",
        product: "Day Ahead Contingency Contracts",
        value: 136.58,
      },
      {
        month: "Jan-23",
        product: "Day Ahead Contingency Contracts",
        value: 55.775662499999505,
      },
      {
        month: "Feb-23",
        product: "Day Ahead Contingency Contracts",
        value: 86.76926749999889,
      },
      {
        month: "Mar-23",
        product: "Day Ahead Contingency Contracts",
        value: 95.4274674999993,
      },
      {
        month: "Apr-23",
        product: "Day Ahead Contingency Contracts",
        value: 57.34666499999932,
      },
      {
        month: "May-23",
        product: "Day Ahead Contingency Contracts",
        value: 77.03548000000083,
      },
      {
        month: "Jun-23",
        product: "Day Ahead Contingency Contracts",
        value: 69.03121750000054,
      },
      {
        month: "Jul-23",
        product: "Day Ahead Contingency Contracts",
        value: 57.77416999999903,
      },
      {
        month: "Aug-23",
        product: "Day Ahead Contingency Contracts",
        value: 78.84662499999979,
      },
      {
        month: "Sep-23",
        product: "Day Ahead Contingency Contracts",
        value: 84.41625000000104,
      },
      {
        month: "Jan-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Daily Contracts",
        value: 1.76,
      },
      {
        month: "Feb-21",
        product: "Daily Contracts",
        value: 0.54,
      },
      {
        month: "Mar-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Daily Contracts",
        value: 2.9,
      },
      {
        month: "May-21",
        product: "Daily Contracts",
        value: 11.08,
      },
      {
        month: "Jun-21",
        product: "Daily Contracts",
        value: 11.95,
      },
      {
        month: "Jul-21",
        product: "Daily Contracts",
        value: 207.83,
      },
      {
        month: "Aug-21",
        product: "Daily Contracts",
        value: 83.02,
      },
      {
        month: "Sep-21",
        product: "Daily Contracts",
        value: 95.26,
      },
      {
        month: "Oct-21",
        product: "Daily Contracts",
        value: 2.98,
      },
      {
        month: "Nov-21",
        product: "Daily Contracts",
        value: 0.43,
      },
      {
        month: "Dec-21",
        product: "Daily Contracts",
        value: 0.31,
      },
      {
        month: "Jan-22",
        product: "Daily Contracts",
        value: 7.02,
      },
      {
        month: "Feb-22",
        product: "Daily Contracts",
        value: 13.76,
      },
      {
        month: "Mar-22",
        product: "Daily Contracts",
        value: 4.89,
      },
      {
        month: "Apr-22",
        product: "Daily Contracts",
        value: 31.9,
      },
      {
        month: "May-22",
        product: "Daily Contracts",
        value: 60.8,
      },
      {
        month: "Jun-22",
        product: "Daily Contracts",
        value: 2.4,
      },
      {
        month: "Jul-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Daily Contracts",
        value: 3.9,
      },
      {
        month: "Oct-22",
        product: "Daily Contracts",
        value: 5.7,
      },
      {
        month: "Nov-22",
        product: "Daily Contracts",
        value: 12.66,
      },
      {
        month: "Dec-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Daily Contracts",
        value: 5.5680000000000005,
      },
      {
        month: "Feb-23",
        product: "Daily Contracts",
        value: 4.2,
      },
      {
        month: "Mar-23",
        product: "Daily Contracts",
        value: 1.488,
      },
      {
        month: "Apr-23",
        product: "Daily Contracts",
        value: 27.57599999999999,
      },
      {
        month: "May-23",
        product: "Daily Contracts",
        value: 5.96872,
      },
      {
        month: "Jun-23",
        product: "Daily Contracts",
        value: 5.272080000000004,
      },
      {
        month: "Jul-23",
        product: "Daily Contracts",
        value: 0.9638400000000005,
      },
      {
        month: "Aug-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Daily Contracts",
        value: 0.768,
      },
      {
        month: "Jan-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Weekly Contracts",
        value: 6.65,
      },
      {
        month: "Jan-21",
        product: "Weekly Contracts",
        value: 16.8,
      },
      {
        month: "Feb-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Weekly Contracts",
        value: 17.25,
      },
      {
        month: "Jun-21",
        product: "Weekly Contracts",
        value: 22.27,
      },
      {
        month: "Jul-21",
        product: "Weekly Contracts",
        value: 16.84,
      },
      {
        month: "Aug-21",
        product: "Weekly Contracts",
        value: 14.29,
      },
      {
        month: "Sep-21",
        product: "Weekly Contracts",
        value: 5.6,
      },
      {
        month: "Oct-21",
        product: "Weekly Contracts",
        value: 0.84,
      },
      {
        month: "Nov-21",
        product: "Weekly Contracts",
        value: 0.34,
      },
      {
        month: "Dec-21",
        product: "Weekly Contracts",
        value: 0.65,
      },
      {
        month: "Jan-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Weekly Contracts",
        value: 6.52,
      },
      {
        month: "Mar-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Weekly Contracts",
        value: 1.79,
      },
      {
        month: "Sep-22",
        product: "Weekly Contracts",
        value: 0.8,
      },
      {
        month: "Oct-22",
        product: "Weekly Contracts",
        value: 4.2,
      },
      {
        month: "Nov-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Weekly Contracts",
        value: 12.096,
      },
      {
        month: "May-23",
        product: "Weekly Contracts",
        value: 6.300000000000001,
      },
      {
        month: "Jun-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Monthly Contracts",
        value: 21.599999999999998,
      },
      {
        month: "May-23",
        product: "Monthly Contracts",
        value: 3.72,
      },
      {
        month: "Jun-23",
        product: "Monthly Contracts",
        value: 3.6,
      },
      {
        month: "Jul-23",
        product: "Monthly Contracts",
        value: 3.72,
      },
      {
        month: "Aug-23",
        product: "Monthly Contracts",
        value: 3.72,
      },
      {
        month: "Sep-23",
        product: "Monthly Contracts",
        value: 4.32,
      },
      {
        month: "Jan-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Any Day Single Sided Contracts",
        value: 2.5500000000000003,
      },
      {
        month: "May-23",
        product: "Any Day Single Sided Contracts",
        value: 65.472,
      },
      {
        month: "Jun-23",
        product: "Any Day Single Sided Contracts",
        value: 28.08,
      },
      {
        month: "Jul-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
    ],
    TAM: [
      {
        month: "Jan-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Intra-Day Contracts",
        value: 16.16,
      },
      {
        month: "Apr-17",
        product: "Intra-Day Contracts",
        value: 24.41,
      },
      {
        month: "May-17",
        product: "Intra-Day Contracts",
        value: 20.2,
      },
      {
        month: "Jun-17",
        product: "Intra-Day Contracts",
        value: 25.1,
      },
      {
        month: "Jul-17",
        product: "Intra-Day Contracts",
        value: 44.74,
      },
      {
        month: "Aug-17",
        product: "Intra-Day Contracts",
        value: 26.55,
      },
      {
        month: "Sep-17",
        product: "Intra-Day Contracts",
        value: 30.21,
      },
      {
        month: "Oct-17",
        product: "Intra-Day Contracts",
        value: 31.89,
      },
      {
        month: "Nov-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Intra-Day Contracts",
        value: 37.12,
      },
      {
        month: "Jan-18",
        product: "Intra-Day Contracts",
        value: 33.44,
      },
      {
        month: "Feb-18",
        product: "Intra-Day Contracts",
        value: 12.54,
      },
      {
        month: "Mar-18",
        product: "Intra-Day Contracts",
        value: 37.97,
      },
      {
        month: "Apr-18",
        product: "Intra-Day Contracts",
        value: 40.37,
      },
      {
        month: "May-18",
        product: "Intra-Day Contracts",
        value: 37.14,
      },
      {
        month: "Jun-18",
        product: "Intra-Day Contracts",
        value: 41.4,
      },
      {
        month: "Jul-18",
        product: "Intra-Day Contracts",
        value: 51.69,
      },
      {
        month: "Aug-18",
        product: "Intra-Day Contracts",
        value: 72.79,
      },
      {
        month: "Sep-18",
        product: "Intra-Day Contracts",
        value: 37.81,
      },
      {
        month: "Oct-18",
        product: "Intra-Day Contracts",
        value: 34.61,
      },
      {
        month: "Nov-18",
        product: "Intra-Day Contracts",
        value: 15.67,
      },
      {
        month: "Dec-18",
        product: "Intra-Day Contracts",
        value: 25.72,
      },
      {
        month: "Jan-19",
        product: "Intra-Day Contracts",
        value: 21.66,
      },
      {
        month: "Feb-19",
        product: "Intra-Day Contracts",
        value: 22.6,
      },
      {
        month: "Mar-19",
        product: "Intra-Day Contracts",
        value: 29.28,
      },
      {
        month: "Apr-19",
        product: "Intra-Day Contracts",
        value: 51.01,
      },
      {
        month: "May-19",
        product: "Intra-Day Contracts",
        value: 60.9,
      },
      {
        month: "Jun-19",
        product: "Intra-Day Contracts",
        value: 72.24,
      },
      {
        month: "Jul-19",
        product: "Intra-Day Contracts",
        value: 83.54,
      },
      {
        month: "Aug-19",
        product: "Intra-Day Contracts",
        value: 97.85,
      },
      {
        month: "Sep-19",
        product: "Intra-Day Contracts",
        value: 62.04,
      },
      {
        month: "Oct-19",
        product: "Intra-Day Contracts",
        value: 47.07,
      },
      {
        month: "Nov-19",
        product: "Intra-Day Contracts",
        value: 28.67,
      },
      {
        month: "Dec-19",
        product: "Intra-Day Contracts",
        value: 45.95,
      },
      {
        month: "Jan-20",
        product: "Intra-Day Contracts",
        value: 44.46,
      },
      {
        month: "Feb-20",
        product: "Intra-Day Contracts",
        value: 52.63,
      },
      {
        month: "Mar-20",
        product: "Intra-Day Contracts",
        value: 32.64,
      },
      {
        month: "Apr-20",
        product: "Intra-Day Contracts",
        value: 21.89,
      },
      {
        month: "May-20",
        product: "Intra-Day Contracts",
        value: 56.65,
      },
      {
        month: "Jun-20",
        product: "Intra-Day Contracts",
        value: 6.39,
      },
      {
        month: "Jul-20",
        product: "Intra-Day Contracts",
        value: 6.06,
      },
      {
        month: "Aug-20",
        product: "Intra-Day Contracts",
        value: 1.87,
      },
      {
        month: "Sep-20",
        product: "Intra-Day Contracts",
        value: 11.33,
      },
      {
        month: "Oct-20",
        product: "Intra-Day Contracts",
        value: 0.89,
      },
      {
        month: "Nov-20",
        product: "Intra-Day Contracts",
        value: 6.46,
      },
      {
        month: "Dec-20",
        product: "Intra-Day Contracts",
        value: 5.04,
      },
      {
        month: "Jan-21",
        product: "Intra-Day Contracts",
        value: 1.76,
      },
      {
        month: "Feb-21",
        product: "Intra-Day Contracts",
        value: 1.31,
      },
      {
        month: "Mar-21",
        product: "Intra-Day Contracts",
        value: 3.62,
      },
      {
        month: "Apr-21",
        product: "Intra-Day Contracts",
        value: 7.5,
      },
      {
        month: "May-21",
        product: "Intra-Day Contracts",
        value: 2.65,
      },
      {
        month: "Jun-21",
        product: "Intra-Day Contracts",
        value: 16.0,
      },
      {
        month: "Jul-21",
        product: "Intra-Day Contracts",
        value: 12.88,
      },
      {
        month: "Aug-21",
        product: "Intra-Day Contracts",
        value: 8.47,
      },
      {
        month: "Sep-21",
        product: "Intra-Day Contracts",
        value: 0.42,
      },
      {
        month: "Oct-21",
        product: "Intra-Day Contracts",
        value: 1.28,
      },
      {
        month: "Nov-21",
        product: "Intra-Day Contracts",
        value: 0.15,
      },
      {
        month: "Dec-21",
        product: "Intra-Day Contracts",
        value: 0.87,
      },
      {
        month: "Jan-22",
        product: "Intra-Day Contracts",
        value: 0.17,
      },
      {
        month: "Feb-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Intra-Day Contracts",
        value: 2.61,
      },
      {
        month: "Apr-22",
        product: "Intra-Day Contracts",
        value: 18.23,
      },
      {
        month: "May-22",
        product: "Intra-Day Contracts",
        value: 6.95,
      },
      {
        month: "Jun-22",
        product: "Intra-Day Contracts",
        value: 3.67,
      },
      {
        month: "Jul-22",
        product: "Intra-Day Contracts",
        value: 1.47,
      },
      {
        month: "Aug-22",
        product: "Intra-Day Contracts",
        value: 1.6,
      },
      {
        month: "Sep-22",
        product: "Intra-Day Contracts",
        value: 6.23,
      },
      {
        month: "Oct-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Intra-Day Contracts",
        value: 0.1,
      },
      {
        month: "Jan-23",
        product: "Intra-Day Contracts",
        value: 0.836,
      },
      {
        month: "Feb-23",
        product: "Intra-Day Contracts",
        value: 0.5199999999999998,
      },
      {
        month: "Mar-23",
        product: "Intra-Day Contracts",
        value: 0.11375000000000002,
      },
      {
        month: "Apr-23",
        product: "Intra-Day Contracts",
        value: 7.8024025,
      },
      {
        month: "May-23",
        product: "Intra-Day Contracts",
        value: 6.281184999999995,
      },
      {
        month: "Jun-23",
        product: "Intra-Day Contracts",
        value: 18.97549999999993,
      },
      {
        month: "Jul-23",
        product: "Intra-Day Contracts",
        value: 13.47450000000001,
      },
      {
        month: "Aug-23",
        product: "Intra-Day Contracts",
        value: 8.818999999999996,
      },
      {
        month: "Sep-23",
        product: "Intra-Day Contracts",
        value: 4.918499999999993,
      },
      {
        month: "Jan-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Day Ahead Contingency Contracts",
        value: 49.71,
      },
      {
        month: "Apr-17",
        product: "Day Ahead Contingency Contracts",
        value: 34.36,
      },
      {
        month: "May-17",
        product: "Day Ahead Contingency Contracts",
        value: 43.83,
      },
      {
        month: "Jun-17",
        product: "Day Ahead Contingency Contracts",
        value: 2.99,
      },
      {
        month: "Jul-17",
        product: "Day Ahead Contingency Contracts",
        value: 14.98,
      },
      {
        month: "Aug-17",
        product: "Day Ahead Contingency Contracts",
        value: 19.2,
      },
      {
        month: "Sep-17",
        product: "Day Ahead Contingency Contracts",
        value: 122.36,
      },
      {
        month: "Oct-17",
        product: "Day Ahead Contingency Contracts",
        value: 207.45,
      },
      {
        month: "Nov-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Day Ahead Contingency Contracts",
        value: 41.29,
      },
      {
        month: "Jan-18",
        product: "Day Ahead Contingency Contracts",
        value: 18.15,
      },
      {
        month: "Feb-18",
        product: "Day Ahead Contingency Contracts",
        value: 5.41,
      },
      {
        month: "Mar-18",
        product: "Day Ahead Contingency Contracts",
        value: 42.77,
      },
      {
        month: "Apr-18",
        product: "Day Ahead Contingency Contracts",
        value: 12.22,
      },
      {
        month: "May-18",
        product: "Day Ahead Contingency Contracts",
        value: 64.55,
      },
      {
        month: "Jun-18",
        product: "Day Ahead Contingency Contracts",
        value: 29.43,
      },
      {
        month: "Jul-18",
        product: "Day Ahead Contingency Contracts",
        value: 68.95,
      },
      {
        month: "Aug-18",
        product: "Day Ahead Contingency Contracts",
        value: 13.82,
      },
      {
        month: "Sep-18",
        product: "Day Ahead Contingency Contracts",
        value: 65.6,
      },
      {
        month: "Oct-18",
        product: "Day Ahead Contingency Contracts",
        value: 349.01,
      },
      {
        month: "Nov-18",
        product: "Day Ahead Contingency Contracts",
        value: 130.25,
      },
      {
        month: "Dec-18",
        product: "Day Ahead Contingency Contracts",
        value: 71.49,
      },
      {
        month: "Jan-19",
        product: "Day Ahead Contingency Contracts",
        value: 80.42,
      },
      {
        month: "Feb-19",
        product: "Day Ahead Contingency Contracts",
        value: 61.83,
      },
      {
        month: "Mar-19",
        product: "Day Ahead Contingency Contracts",
        value: 45.7,
      },
      {
        month: "Apr-19",
        product: "Day Ahead Contingency Contracts",
        value: 281.43,
      },
      {
        month: "May-19",
        product: "Day Ahead Contingency Contracts",
        value: 256.34,
      },
      {
        month: "Jun-19",
        product: "Day Ahead Contingency Contracts",
        value: 199.36,
      },
      {
        month: "Jul-19",
        product: "Day Ahead Contingency Contracts",
        value: 63.72,
      },
      {
        month: "Aug-19",
        product: "Day Ahead Contingency Contracts",
        value: 1.62,
      },
      {
        month: "Sep-19",
        product: "Day Ahead Contingency Contracts",
        value: 42.39,
      },
      {
        month: "Oct-19",
        product: "Day Ahead Contingency Contracts",
        value: 16.87,
      },
      {
        month: "Nov-19",
        product: "Day Ahead Contingency Contracts",
        value: 13.67,
      },
      {
        month: "Dec-19",
        product: "Day Ahead Contingency Contracts",
        value: 14.47,
      },
      {
        month: "Jan-20",
        product: "Day Ahead Contingency Contracts",
        value: 117.05,
      },
      {
        month: "Feb-20",
        product: "Day Ahead Contingency Contracts",
        value: 42.33,
      },
      {
        month: "Mar-20",
        product: "Day Ahead Contingency Contracts",
        value: 45.72,
      },
      {
        month: "Apr-20",
        product: "Day Ahead Contingency Contracts",
        value: 2.77,
      },
      {
        month: "May-20",
        product: "Day Ahead Contingency Contracts",
        value: 27.32,
      },
      {
        month: "Jun-20",
        product: "Day Ahead Contingency Contracts",
        value: 5.51,
      },
      {
        month: "Jul-20",
        product: "Day Ahead Contingency Contracts",
        value: 17.75,
      },
      {
        month: "Aug-20",
        product: "Day Ahead Contingency Contracts",
        value: 1.62,
      },
      {
        month: "Sep-20",
        product: "Day Ahead Contingency Contracts",
        value: 42.39,
      },
      {
        month: "Oct-20",
        product: "Day Ahead Contingency Contracts",
        value: 16.87,
      },
      {
        month: "Nov-20",
        product: "Day Ahead Contingency Contracts",
        value: 13.67,
      },
      {
        month: "Dec-20",
        product: "Day Ahead Contingency Contracts",
        value: 14.47,
      },
      {
        month: "Jan-21",
        product: "Day Ahead Contingency Contracts",
        value: 48.3,
      },
      {
        month: "Feb-21",
        product: "Day Ahead Contingency Contracts",
        value: 58.26,
      },
      {
        month: "Mar-21",
        product: "Day Ahead Contingency Contracts",
        value: 46.66,
      },
      {
        month: "Apr-21",
        product: "Day Ahead Contingency Contracts",
        value: 63.07,
      },
      {
        month: "May-21",
        product: "Day Ahead Contingency Contracts",
        value: 122.9,
      },
      {
        month: "Jun-21",
        product: "Day Ahead Contingency Contracts",
        value: 316.43,
      },
      {
        month: "Jul-21",
        product: "Day Ahead Contingency Contracts",
        value: 263.75,
      },
      {
        month: "Aug-21",
        product: "Day Ahead Contingency Contracts",
        value: 110.1,
      },
      {
        month: "Sep-21",
        product: "Day Ahead Contingency Contracts",
        value: 68.36,
      },
      {
        month: "Oct-21",
        product: "Day Ahead Contingency Contracts",
        value: 153.9,
      },
      {
        month: "Nov-21",
        product: "Day Ahead Contingency Contracts",
        value: 107.24,
      },
      {
        month: "Dec-21",
        product: "Day Ahead Contingency Contracts",
        value: 72.9,
      },
      {
        month: "Jan-22",
        product: "Day Ahead Contingency Contracts",
        value: 102.31,
      },
      {
        month: "Feb-22",
        product: "Day Ahead Contingency Contracts",
        value: 163.0,
      },
      {
        month: "Mar-22",
        product: "Day Ahead Contingency Contracts",
        value: 387.89,
      },
      {
        month: "Apr-22",
        product: "Day Ahead Contingency Contracts",
        value: 533.5,
      },
      {
        month: "May-22",
        product: "Day Ahead Contingency Contracts",
        value: 449.53,
      },
      {
        month: "Jun-22",
        product: "Day Ahead Contingency Contracts",
        value: 624.11,
      },
      {
        month: "Jul-22",
        product: "Day Ahead Contingency Contracts",
        value: 399.94,
      },
      {
        month: "Aug-22",
        product: "Day Ahead Contingency Contracts",
        value: 598.89,
      },
      {
        month: "Sep-22",
        product: "Day Ahead Contingency Contracts",
        value: 729.28,
      },
      {
        month: "Oct-22",
        product: "Day Ahead Contingency Contracts",
        value: 523.9,
      },
      {
        month: "Nov-22",
        product: "Day Ahead Contingency Contracts",
        value: 328.93,
      },
      {
        month: "Dec-22",
        product: "Day Ahead Contingency Contracts",
        value: 530.8,
      },
      {
        month: "Jan-23",
        product: "Day Ahead Contingency Contracts",
        value: 502.5889999999788,
      },
      {
        month: "Feb-23",
        product: "Day Ahead Contingency Contracts",
        value: 679.6524999999974,
      },
      {
        month: "Mar-23",
        product: "Day Ahead Contingency Contracts",
        value: 689.2911399999917,
      },
      {
        month: "Apr-23",
        product: "Day Ahead Contingency Contracts",
        value: 515.6705225000065,
      },
      {
        month: "May-23",
        product: "Day Ahead Contingency Contracts",
        value: 531.9662175000038,
      },
      {
        month: "Jun-23",
        product: "Day Ahead Contingency Contracts",
        value: 776.1507849999966,
      },
      {
        month: "Jul-23",
        product: "Day Ahead Contingency Contracts",
        value: 734.6370199999775,
      },
      {
        month: "Aug-23",
        product: "Day Ahead Contingency Contracts",
        value: 896.5889750000604,
      },
      {
        month: "Sep-23",
        product: "Day Ahead Contingency Contracts",
        value: 758.7917749999913,
      },
      {
        month: "Jan-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Daily Contracts",
        value: 70.57,
      },
      {
        month: "Sep-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Daily Contracts",
        value: 50.4,
      },
      {
        month: "Nov-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Daily Contracts",
        value: 57.46,
      },
      {
        month: "Apr-18",
        product: "Daily Contracts",
        value: 37.9,
      },
      {
        month: "May-18",
        product: "Daily Contracts",
        value: 151.2,
      },
      {
        month: "Jun-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Daily Contracts",
        value: 164.04,
      },
      {
        month: "Nov-18",
        product: "Daily Contracts",
        value: 24.0,
      },
      {
        month: "Dec-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Daily Contracts",
        value: 87.72,
      },
      {
        month: "Jul-19",
        product: "Daily Contracts",
        value: 237.15,
      },
      {
        month: "Aug-19",
        product: "Daily Contracts",
        value: 269.52,
      },
      {
        month: "Sep-19",
        product: "Daily Contracts",
        value: 186.24,
      },
      {
        month: "Oct-19",
        product: "Daily Contracts",
        value: 239.32,
      },
      {
        month: "Nov-19",
        product: "Daily Contracts",
        value: 267.82,
      },
      {
        month: "Dec-19",
        product: "Daily Contracts",
        value: 162.47,
      },
      {
        month: "Jan-20",
        product: "Daily Contracts",
        value: 98.4,
      },
      {
        month: "Feb-20",
        product: "Daily Contracts",
        value: 131.52,
      },
      {
        month: "Mar-20",
        product: "Daily Contracts",
        value: 177.6,
      },
      {
        month: "Apr-20",
        product: "Daily Contracts",
        value: 173.28,
      },
      {
        month: "May-20",
        product: "Daily Contracts",
        value: 204.64,
      },
      {
        month: "Jun-20",
        product: "Daily Contracts",
        value: 63.24,
      },
      {
        month: "Jul-20",
        product: "Daily Contracts",
        value: 38.64,
      },
      {
        month: "Aug-20",
        product: "Daily Contracts",
        value: 117.04,
      },
      {
        month: "Sep-20",
        product: "Daily Contracts",
        value: 38.52,
      },
      {
        month: "Oct-20",
        product: "Daily Contracts",
        value: 69.4,
      },
      {
        month: "Nov-20",
        product: "Daily Contracts",
        value: 170.08,
      },
      {
        month: "Dec-20",
        product: "Daily Contracts",
        value: 416.21,
      },
      {
        month: "Jan-21",
        product: "Daily Contracts",
        value: 474.02,
      },
      {
        month: "Feb-21",
        product: "Daily Contracts",
        value: 372.67,
      },
      {
        month: "Mar-21",
        product: "Daily Contracts",
        value: 183.9,
      },
      {
        month: "Apr-21",
        product: "Daily Contracts",
        value: 278.01,
      },
      {
        month: "May-21",
        product: "Daily Contracts",
        value: 257.07,
      },
      {
        month: "Jun-21",
        product: "Daily Contracts",
        value: 308.48,
      },
      {
        month: "Jul-21",
        product: "Daily Contracts",
        value: 484.63,
      },
      {
        month: "Aug-21",
        product: "Daily Contracts",
        value: 498.66,
      },
      {
        month: "Sep-21",
        product: "Daily Contracts",
        value: 124.09,
      },
      {
        month: "Oct-21",
        product: "Daily Contracts",
        value: 69.6,
      },
      {
        month: "Nov-21",
        product: "Daily Contracts",
        value: 195.36,
      },
      {
        month: "Dec-21",
        product: "Daily Contracts",
        value: 276.0,
      },
      {
        month: "Jan-22",
        product: "Daily Contracts",
        value: 287.79,
      },
      {
        month: "Feb-22",
        product: "Daily Contracts",
        value: 363.8,
      },
      {
        month: "Mar-22",
        product: "Daily Contracts",
        value: 432.21,
      },
      {
        month: "Apr-22",
        product: "Daily Contracts",
        value: 601.05,
      },
      {
        month: "May-22",
        product: "Daily Contracts",
        value: 713.69,
      },
      {
        month: "Jun-22",
        product: "Daily Contracts",
        value: 131.25,
      },
      {
        month: "Jul-22",
        product: "Daily Contracts",
        value: 4.8,
      },
      {
        month: "Aug-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Daily Contracts",
        value: 28.8,
      },
      {
        month: "Oct-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Daily Contracts",
        value: 33.6,
      },
      {
        month: "Dec-22",
        product: "Daily Contracts",
        value: 92.38,
      },
      {
        month: "Jan-23",
        product: "Daily Contracts",
        value: 90.0,
      },
      {
        month: "Feb-23",
        product: "Daily Contracts",
        value: 108.0,
      },
      {
        month: "Mar-23",
        product: "Daily Contracts",
        value: 15.5034,
      },
      {
        month: "Apr-23",
        product: "Daily Contracts",
        value: 76.43900000000002,
      },
      {
        month: "May-23",
        product: "Daily Contracts",
        value: 284.23271500000004,
      },
      {
        month: "Jun-23",
        product: "Daily Contracts",
        value: 75.25774999999996,
      },
      {
        month: "Jul-23",
        product: "Daily Contracts",
        value: 69.6,
      },
      {
        month: "Aug-23",
        product: "Daily Contracts",
        value: 229.99034999999998,
      },
      {
        month: "Sep-23",
        product: "Daily Contracts",
        value: 534.8906800000005,
      },
      {
        month: "Jan-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Weekly Contracts",
        value: 43.51,
      },
      {
        month: "May-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Weekly Contracts",
        value: 16.8,
      },
      {
        month: "Jul-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Weekly Contracts",
        value: 171.36,
      },
      {
        month: "Apr-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Weekly Contracts",
        value: 85.86,
      },
      {
        month: "Aug-19",
        product: "Weekly Contracts",
        value: 300.55,
      },
      {
        month: "Sep-19",
        product: "Weekly Contracts",
        value: 106.37,
      },
      {
        month: "Oct-19",
        product: "Weekly Contracts",
        value: 101.87,
      },
      {
        month: "Nov-19",
        product: "Weekly Contracts",
        value: 110.4,
      },
      {
        month: "Dec-19",
        product: "Weekly Contracts",
        value: 155.84,
      },
      {
        month: "Jan-20",
        product: "Weekly Contracts",
        value: 11.58,
      },
      {
        month: "Feb-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Weekly Contracts",
        value: 64.05,
      },
      {
        month: "Apr-20",
        product: "Weekly Contracts",
        value: 162.0,
      },
      {
        month: "May-20",
        product: "Weekly Contracts",
        value: 142.77,
      },
      {
        month: "Jun-20",
        product: "Weekly Contracts",
        value: 25.2,
      },
      {
        month: "Jul-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Weekly Contracts",
        value: 14.4,
      },
      {
        month: "Oct-20",
        product: "Weekly Contracts",
        value: 132.0,
      },
      {
        month: "Nov-20",
        product: "Weekly Contracts",
        value: 55.2,
      },
      {
        month: "Dec-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Weekly Contracts",
        value: 18.72,
      },
      {
        month: "May-22",
        product: "Weekly Contracts",
        value: 18.43,
      },
      {
        month: "Jun-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Weekly Contracts",
        value: 33.6,
      },
      {
        month: "Aug-22",
        product: "Weekly Contracts",
        value: 122.4,
      },
      {
        month: "Sep-22",
        product: "Weekly Contracts",
        value: 111.12,
      },
      {
        month: "Oct-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Weekly Contracts",
        value: 165.6,
      },
      {
        month: "Dec-22",
        product: "Weekly Contracts",
        value: 100.8,
      },
      {
        month: "Jan-23",
        product: "Weekly Contracts",
        value: 105.6,
      },
      {
        month: "Feb-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Weekly Contracts",
        value: 36.74383749999998,
      },
      {
        month: "Apr-23",
        product: "Weekly Contracts",
        value: 73.5,
      },
      {
        month: "May-23",
        product: "Weekly Contracts",
        value: 90.64999999999999,
      },
      {
        month: "Jun-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Weekly Contracts",
        value: 75.6,
      },
      {
        month: "Aug-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Monthly Contracts",
        value: 4.32,
      },
      {
        month: "Oct-22",
        product: "Monthly Contracts",
        value: 97.46,
      },
      {
        month: "Nov-22",
        product: "Monthly Contracts",
        value: 19.2,
      },
      {
        month: "Dec-22",
        product: "Monthly Contracts",
        value: 98.39,
      },
      {
        month: "Jan-23",
        product: "Monthly Contracts",
        value: 37.2,
      },
      {
        month: "Feb-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Monthly Contracts",
        value: 297.6,
      },
      {
        month: "Apr-23",
        product: "Monthly Contracts",
        value: 119.0382,
      },
      {
        month: "May-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Monthly Contracts",
        value: 72.06061571000001,
      },
      {
        month: "Sep-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Any Day Single Sided Contracts",
        value: 166.065,
      },
      {
        month: "Feb-23",
        product: "Any Day Single Sided Contracts",
        value: 165.84,
      },
      {
        month: "Mar-23",
        product: "Any Day Single Sided Contracts",
        value: 47.7,
      },
      {
        month: "Apr-23",
        product: "Any Day Single Sided Contracts",
        value: 48.93,
      },
      {
        month: "May-23",
        product: "Any Day Single Sided Contracts",
        value: 144.73779499999998,
      },
      {
        month: "Jun-23",
        product: "Any Day Single Sided Contracts",
        value: 247.23154999999997,
      },
      {
        month: "Jul-23",
        product: "Any Day Single Sided Contracts",
        value: 142.40436000000003,
      },
      {
        month: "Aug-23",
        product: "Any Day Single Sided Contracts",
        value: 466.6793814199996,
      },
      {
        month: "Sep-23",
        product: "Any Day Single Sided Contracts",
        value: 596.8184775000001,
      },
    ],
  },
  PXIL: {
    Collective: [
      {
        month: "Jan-17",
        product: "DAM",
        value: 5.26,
      },
      {
        month: "Feb-17",
        product: "DAM",
        value: 7.84,
      },
      {
        month: "Mar-17",
        product: "DAM",
        value: 56.76,
      },
      {
        month: "Apr-17",
        product: "DAM",
        value: 26.86,
      },
      {
        month: "May-17",
        product: "DAM",
        value: 5.3,
      },
      {
        month: "Jun-17",
        product: "DAM",
        value: 15.72,
      },
      {
        month: "Jul-17",
        product: "DAM",
        value: 5.16,
      },
      {
        month: "Aug-17",
        product: "DAM",
        value: 34.56,
      },
      {
        month: "Sep-17",
        product: "DAM",
        value: 279.94,
      },
      {
        month: "Oct-17",
        product: "DAM",
        value: 281.76,
      },
      {
        month: "Nov-17",
        product: "DAM",
        value: 27.3,
      },
      {
        month: "Dec-17",
        product: "DAM",
        value: 2.36,
      },
      {
        month: "Jan-18",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "DAM",
        value: 27.6,
      },
      {
        month: "Mar-18",
        product: "DAM",
        value: 23.93,
      },
      {
        month: "Apr-18",
        product: "DAM",
        value: 5.8,
      },
      {
        month: "May-18",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "DAM",
        value: 15.39,
      },
      {
        month: "Jul-18",
        product: "DAM",
        value: 26.45,
      },
      {
        month: "Aug-18",
        product: "DAM",
        value: 4.94,
      },
      {
        month: "Sep-18",
        product: "DAM",
        value: 15.76,
      },
      {
        month: "Oct-18",
        product: "DAM",
        value: 4.8,
      },
      {
        month: "Nov-18",
        product: "DAM",
        value: 2.58,
      },
      {
        month: "Dec-18",
        product: "DAM",
        value: 0.3,
      },
      {
        month: "Jan-19",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "DAM",
        value: 0.23,
      },
      {
        month: "Mar-19",
        product: "DAM",
        value: 10.15,
      },
      {
        month: "Apr-19",
        product: "DAM",
        value: 31.43,
      },
      {
        month: "May-19",
        product: "DAM",
        value: 1.17,
      },
      {
        month: "Jun-19",
        product: "DAM",
        value: 0.42,
      },
      {
        month: "Jul-19",
        product: "DAM",
        value: 0.35,
      },
      {
        month: "Aug-19",
        product: "DAM",
        value: 0.35,
      },
      {
        month: "Sep-19",
        product: "DAM",
        value: 1.03,
      },
      {
        month: "Oct-19",
        product: "DAM",
        value: 9.81,
      },
      {
        month: "Nov-19",
        product: "DAM",
        value: 0.42,
      },
      {
        month: "Dec-19",
        product: "DAM",
        value: 0.46,
      },
      {
        month: "Jan-20",
        product: "DAM",
        value: 0.92,
      },
      {
        month: "Feb-20",
        product: "DAM",
        value: 0.28,
      },
      {
        month: "Mar-20",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "DAM",
        value: 22.24,
      },
      {
        month: "Jun-20",
        product: "DAM",
        value: 15.03,
      },
      {
        month: "Jul-20",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "DAM",
        value: 14.1,
      },
      {
        month: "Sep-20",
        product: "DAM",
        value: 60.2,
      },
      {
        month: "Oct-20",
        product: "DAM",
        value: 49.57,
      },
      {
        month: "Nov-20",
        product: "DAM",
        value: 48.62,
      },
      {
        month: "Dec-20",
        product: "DAM",
        value: 5.42,
      },
      {
        month: "Jan-21",
        product: "DAM",
        value: 7.63,
      },
      {
        month: "Feb-21",
        product: "DAM",
        value: 7.44,
      },
      {
        month: "Mar-21",
        product: "DAM",
        value: 10.94,
      },
      {
        month: "Apr-21",
        product: "DAM",
        value: 4.73,
      },
      {
        month: "May-21",
        product: "DAM",
        value: 3.32,
      },
      {
        month: "Jun-21",
        product: "DAM",
        value: 21.91,
      },
      {
        month: "Jul-21",
        product: "DAM",
        value: 2.76,
      },
      {
        month: "Aug-21",
        product: "DAM",
        value: 5.12,
      },
      {
        month: "Sep-21",
        product: "DAM",
        value: 1.27,
      },
      {
        month: "Oct-21",
        product: "DAM",
        value: 0.37,
      },
      {
        month: "Nov-21",
        product: "DAM",
        value: 0.74,
      },
      {
        month: "Dec-21",
        product: "DAM",
        value: 0.88,
      },
      {
        month: "Jan-22",
        product: "DAM",
        value: 0.56,
      },
      {
        month: "Feb-22",
        product: "DAM",
        value: 0.76,
      },
      {
        month: "Mar-22",
        product: "DAM",
        value: 0.2,
      },
      {
        month: "Apr-22",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "DAM",
        value: 13.02,
      },
      {
        month: "Jun-22",
        product: "DAM",
        value: 116.2,
      },
      {
        month: "Jul-22",
        product: "DAM",
        value: 31.78,
      },
      {
        month: "Aug-22",
        product: "DAM",
        value: 10.12,
      },
      {
        month: "Sep-22",
        product: "DAM",
        value: 12.89,
      },
      {
        month: "Oct-22",
        product: "DAM",
        value: 3.01,
      },
      {
        month: "Nov-22",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "DAM",
        value: 0.12,
      },
      {
        month: "Feb-23",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "DAM",
        value: 1.56,
      },
      {
        month: "Jun-23",
        product: "DAM",
        value: 0.03,
      },
      {
        month: "Jul-23",
        product: "DAM",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "DAM",
        value: 16.34,
      },
      {
        month: "Sep-23",
        product: "DAM",
        value: 11.67,
      },
      {
        month: "Jan-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Feb-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Mar-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Apr-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "May-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jun-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jul-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Aug-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Sep-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Oct-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Nov-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Dec-17",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jan-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Feb-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Mar-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Apr-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "May-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jun-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jul-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Aug-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Sep-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Oct-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Nov-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Dec-18",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jan-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Feb-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Mar-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Apr-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "May-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jun-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jul-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Aug-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Sep-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Oct-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Nov-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Dec-19",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jan-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Feb-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Mar-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Apr-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "May-20",
        product: "RTM",
        value: 0,
      },
      {
        month: "Jun-20",
        product: "RTM",
        value: 1.86,
      },
      {
        month: "Jul-20",
        product: "RTM",
        value: 0.43,
      },
      {
        month: "Aug-20",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "RTM",
        value: 0.1,
      },
      {
        month: "May-22",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "RTM",
        value: 1.03,
      },
      {
        month: "Jul-22",
        product: "RTM",
        value: 10.73,
      },
      {
        month: "Aug-22",
        product: "RTM",
        value: 0.15,
      },
      {
        month: "Sep-22",
        product: "RTM",
        value: 0.55,
      },
      {
        month: "Oct-22",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "RTM",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "RTM",
        value: 0.63,
      },
      {
        month: "Sep-23",
        product: "RTM",
        value: 0.25,
      },
      {
        month: "Jan-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Aug-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Sep-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Oct-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Nov-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Dec-17",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jan-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Aug-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Sep-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Oct-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Nov-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Dec-18",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jan-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Aug-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Sep-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Oct-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Nov-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Dec-19",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jan-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Aug-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Sep-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Oct-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Nov-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Dec-20",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jan-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Feb-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Mar-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Apr-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "May-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jun-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Jul-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Aug-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Sep-21",
        product: "GDAM",
        value: 0,
      },
      {
        month: "Oct-21",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "GDAM",
        value: 0.16,
      },
      {
        month: "Aug-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "GDAM",
        value: 0.25,
      },
      {
        month: "Oct-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "GDAM",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "GDAM",
        value: 0.0,
      },
    ],
    GTAM: [
      {
        month: "Jan-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Intra-Day Contracts",
        value: 0.39,
      },
      {
        month: "Apr-21",
        product: "Intra-Day Contracts",
        value: 0.03,
      },
      {
        month: "May-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Intra-Day Contracts",
        value: 2.26,
      },
      {
        month: "Jul-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Intra-Day Contracts",
        value: 0.42,
      },
      {
        month: "Sep-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Intra-Day Contracts",
        value: 1.55,
      },
      {
        month: "Jan-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Intra-Day Contracts",
        value: 2.83,
      },
      {
        month: "Apr-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Intra-Day Contracts",
        value: 1.35,
      },
      {
        month: "Jun-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Intra-Day Contracts",
        value: 0.34775,
      },
      {
        month: "Apr-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Day Ahead Contingency Contracts",
        value: 12.68,
      },
      {
        month: "Sep-21",
        product: "Day Ahead Contingency Contracts",
        value: 53.06,
      },
      {
        month: "Oct-21",
        product: "Day Ahead Contingency Contracts",
        value: 56.05,
      },
      {
        month: "Nov-21",
        product: "Day Ahead Contingency Contracts",
        value: 66.65,
      },
      {
        month: "Dec-21",
        product: "Day Ahead Contingency Contracts",
        value: 229.79,
      },
      {
        month: "Jan-22",
        product: "Day Ahead Contingency Contracts",
        value: 156.17,
      },
      {
        month: "Feb-22",
        product: "Day Ahead Contingency Contracts",
        value: 389.41,
      },
      {
        month: "Mar-22",
        product: "Day Ahead Contingency Contracts",
        value: 315.03,
      },
      {
        month: "Apr-22",
        product: "Day Ahead Contingency Contracts",
        value: 207.36,
      },
      {
        month: "May-22",
        product: "Day Ahead Contingency Contracts",
        value: 255.63,
      },
      {
        month: "Jun-22",
        product: "Day Ahead Contingency Contracts",
        value: 60.73,
      },
      {
        month: "Jul-22",
        product: "Day Ahead Contingency Contracts",
        value: 51.61,
      },
      {
        month: "Aug-22",
        product: "Day Ahead Contingency Contracts",
        value: 61.34,
      },
      {
        month: "Sep-22",
        product: "Day Ahead Contingency Contracts",
        value: 25.47,
      },
      {
        month: "Oct-22",
        product: "Day Ahead Contingency Contracts",
        value: 32.86,
      },
      {
        month: "Nov-22",
        product: "Day Ahead Contingency Contracts",
        value: 87.02,
      },
      {
        month: "Dec-22",
        product: "Day Ahead Contingency Contracts",
        value: 67.14,
      },
      {
        month: "Jan-23",
        product: "Day Ahead Contingency Contracts",
        value: 44.83714000000001,
      },
      {
        month: "Feb-23",
        product: "Day Ahead Contingency Contracts",
        value: 39.294425000000025,
      },
      {
        month: "Mar-23",
        product: "Day Ahead Contingency Contracts",
        value: 30.445550000000008,
      },
      {
        month: "Apr-23",
        product: "Day Ahead Contingency Contracts",
        value: 16.548800000000004,
      },
      {
        month: "May-23",
        product: "Day Ahead Contingency Contracts",
        value: 41.65220000000003,
      },
      {
        month: "Jun-23",
        product: "Day Ahead Contingency Contracts",
        value: 41.64975000000007,
      },
      {
        month: "Jul-23",
        product: "Day Ahead Contingency Contracts",
        value: 14.85732999999999,
      },
      {
        month: "Aug-23",
        product: "Day Ahead Contingency Contracts",
        value: 29.43882500000006,
      },
      {
        month: "Sep-23",
        product: "Day Ahead Contingency Contracts",
        value: 26.30745000000011,
      },
      {
        month: "Jan-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Any Day Contracts",
        value: 5.71,
      },
      {
        month: "May-21",
        product: "Any Day Contracts",
        value: 0.6,
      },
      {
        month: "Jun-21",
        product: "Any Day Contracts",
        value: 25.24,
      },
      {
        month: "Jul-21",
        product: "Any Day Contracts",
        value: 16.77,
      },
      {
        month: "Aug-21",
        product: "Any Day Contracts",
        value: 19.7,
      },
      {
        month: "Sep-21",
        product: "Any Day Contracts",
        value: 1.3,
      },
      {
        month: "Oct-21",
        product: "Any Day Contracts",
        value: 3.66,
      },
      {
        month: "Nov-21",
        product: "Any Day Contracts",
        value: 65.26,
      },
      {
        month: "Dec-21",
        product: "Any Day Contracts",
        value: 7.0,
      },
      {
        month: "Jan-22",
        product: "Any Day Contracts",
        value: 2.78,
      },
      {
        month: "Feb-22",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Any Day Contracts",
        value: 1.03,
      },
      {
        month: "Apr-22",
        product: "Any Day Contracts",
        value: 1.25,
      },
      {
        month: "May-22",
        product: "Any Day Contracts",
        value: 130.0,
      },
      {
        month: "Jun-22",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "Any Day Single Sided Contracts",
        value: 1.2400000000000009,
      },
      {
        month: "Jun-23",
        product: "Any Day Single Sided Contracts",
        value: 1.472,
      },
      {
        month: "Jul-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Any Day Single Sided Contracts",
        value: 7.488000000000002,
      },
    ],
    TAM: [
      {
        month: "Jan-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Intra-Day Contracts",
        value: 14.71,
      },
      {
        month: "Jun-17",
        product: "Intra-Day Contracts",
        value: 13.94,
      },
      {
        month: "Jul-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Intra-Day Contracts",
        value: 71.88,
      },
      {
        month: "Oct-17",
        product: "Intra-Day Contracts",
        value: 21.28,
      },
      {
        month: "Nov-17",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Intra-Day Contracts",
        value: 15.13,
      },
      {
        month: "Jan-18",
        product: "Intra-Day Contracts",
        value: 13.79,
      },
      {
        month: "Feb-18",
        product: "Intra-Day Contracts",
        value: 7.23,
      },
      {
        month: "Mar-18",
        product: "Intra-Day Contracts",
        value: 14.79,
      },
      {
        month: "Apr-18",
        product: "Intra-Day Contracts",
        value: 28.86,
      },
      {
        month: "May-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Intra-Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Intra-Day Contracts",
        value: 40.16,
      },
      {
        month: "Oct-18",
        product: "Intra-Day Contracts",
        value: 113.5,
      },
      {
        month: "Nov-18",
        product: "Intra-Day Contracts",
        value: 55.19,
      },
      {
        month: "Dec-18",
        product: "Intra-Day Contracts",
        value: 35.6,
      },
      {
        month: "Jan-19",
        product: "Intra-Day Contracts",
        value: 68.52,
      },
      {
        month: "Feb-19",
        product: "Intra-Day Contracts",
        value: 30.35,
      },
      {
        month: "Mar-19",
        product: "Intra-Day Contracts",
        value: 86.79,
      },
      {
        month: "Apr-19",
        product: "Intra-Day Contracts",
        value: 90.24,
      },
      {
        month: "May-19",
        product: "Intra-Day Contracts",
        value: 52.01,
      },
      {
        month: "Jun-19",
        product: "Intra-Day Contracts",
        value: 116.7,
      },
      {
        month: "Jul-19",
        product: "Intra-Day Contracts",
        value: 157.94,
      },
      {
        month: "Aug-19",
        product: "Intra-Day Contracts",
        value: 223.11,
      },
      {
        month: "Sep-19",
        product: "Intra-Day Contracts",
        value: 64.24,
      },
      {
        month: "Oct-19",
        product: "Intra-Day Contracts",
        value: 46.02,
      },
      {
        month: "Nov-19",
        product: "Intra-Day Contracts",
        value: 40.41,
      },
      {
        month: "Dec-19",
        product: "Intra-Day Contracts",
        value: 19.53,
      },
      {
        month: "Jan-20",
        product: "Intra-Day Contracts",
        value: 13.0,
      },
      {
        month: "Feb-20",
        product: "Intra-Day Contracts",
        value: 18.63,
      },
      {
        month: "Mar-20",
        product: "Intra-Day Contracts",
        value: 10.57,
      },
      {
        month: "Apr-20",
        product: "Intra-Day Contracts",
        value: 8.95,
      },
      {
        month: "May-20",
        product: "Intra-Day Contracts",
        value: 35.74,
      },
      {
        month: "Jun-20",
        product: "Intra-Day Contracts",
        value: 17.24,
      },
      {
        month: "Jul-20",
        product: "Intra-Day Contracts",
        value: 19.81,
      },
      {
        month: "Aug-20",
        product: "Intra-Day Contracts",
        value: 18.77,
      },
      {
        month: "Sep-20",
        product: "Intra-Day Contracts",
        value: 26.36,
      },
      {
        month: "Oct-20",
        product: "Intra-Day Contracts",
        value: 20.6,
      },
      {
        month: "Nov-20",
        product: "Intra-Day Contracts",
        value: 20.35,
      },
      {
        month: "Dec-20",
        product: "Intra-Day Contracts",
        value: 4.95,
      },
      {
        month: "Jan-21",
        product: "Intra-Day Contracts",
        value: 33.35,
      },
      {
        month: "Feb-21",
        product: "Intra-Day Contracts",
        value: 14.55,
      },
      {
        month: "Mar-21",
        product: "Intra-Day Contracts",
        value: 12.07,
      },
      {
        month: "Apr-21",
        product: "Intra-Day Contracts",
        value: 94.17,
      },
      {
        month: "May-21",
        product: "Intra-Day Contracts",
        value: 69.18,
      },
      {
        month: "Jun-21",
        product: "Intra-Day Contracts",
        value: 72.03,
      },
      {
        month: "Jul-21",
        product: "Intra-Day Contracts",
        value: 119.1,
      },
      {
        month: "Aug-21",
        product: "Intra-Day Contracts",
        value: 13.94,
      },
      {
        month: "Sep-21",
        product: "Intra-Day Contracts",
        value: 3.4,
      },
      {
        month: "Oct-21",
        product: "Intra-Day Contracts",
        value: 4.17,
      },
      {
        month: "Nov-21",
        product: "Intra-Day Contracts",
        value: 1.66,
      },
      {
        month: "Dec-21",
        product: "Intra-Day Contracts",
        value: 6.05,
      },
      {
        month: "Jan-22",
        product: "Intra-Day Contracts",
        value: 0.25,
      },
      {
        month: "Feb-22",
        product: "Intra-Day Contracts",
        value: 1.41,
      },
      {
        month: "Mar-22",
        product: "Intra-Day Contracts",
        value: 1.34,
      },
      {
        month: "Apr-22",
        product: "Intra-Day Contracts",
        value: 16.89,
      },
      {
        month: "May-22",
        product: "Intra-Day Contracts",
        value: 13.26,
      },
      {
        month: "Jun-22",
        product: "Intra-Day Contracts",
        value: 3.78,
      },
      {
        month: "Jul-22",
        product: "Intra-Day Contracts",
        value: 4.75,
      },
      {
        month: "Aug-22",
        product: "Intra-Day Contracts",
        value: 9.04,
      },
      {
        month: "Sep-22",
        product: "Intra-Day Contracts",
        value: 6.79,
      },
      {
        month: "Oct-22",
        product: "Intra-Day Contracts",
        value: 5.15,
      },
      {
        month: "Nov-22",
        product: "Intra-Day Contracts",
        value: 1.51,
      },
      {
        month: "Dec-22",
        product: "Intra-Day Contracts",
        value: 0.73,
      },
      {
        month: "Jan-23",
        product: "Intra-Day Contracts",
        value: 5.124999999999999,
      },
      {
        month: "Feb-23",
        product: "Intra-Day Contracts",
        value: 5.93075,
      },
      {
        month: "Mar-23",
        product: "Intra-Day Contracts",
        value: 0.4235,
      },
      {
        month: "Apr-23",
        product: "Intra-Day Contracts",
        value: 8.075500000000002,
      },
      {
        month: "May-23",
        product: "Intra-Day Contracts",
        value: 21.23470499999999,
      },
      {
        month: "Jun-23",
        product: "Intra-Day Contracts",
        value: 20.270374999999998,
      },
      {
        month: "Jul-23",
        product: "Intra-Day Contracts",
        value: 5.12244,
      },
      {
        month: "Aug-23",
        product: "Intra-Day Contracts",
        value: 9.516040000000002,
      },
      {
        month: "Sep-23",
        product: "Intra-Day Contracts",
        value: 10.989889999999999,
      },
      {
        month: "Jan-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.38,
      },
      {
        month: "Mar-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.43,
      },
      {
        month: "Apr-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.14,
      },
      {
        month: "Jun-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Day Ahead Contingency Contracts",
        value: 8.48,
      },
      {
        month: "Aug-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Day Ahead Contingency Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Day Ahead Contingency Contracts",
        value: 101.58,
      },
      {
        month: "Sep-21",
        product: "Day Ahead Contingency Contracts",
        value: 143.61,
      },
      {
        month: "Oct-21",
        product: "Day Ahead Contingency Contracts",
        value: 230.38,
      },
      {
        month: "Nov-21",
        product: "Day Ahead Contingency Contracts",
        value: 241.12,
      },
      {
        month: "Dec-21",
        product: "Day Ahead Contingency Contracts",
        value: 253.58,
      },
      {
        month: "Jan-22",
        product: "Day Ahead Contingency Contracts",
        value: 205.75,
      },
      {
        month: "Feb-22",
        product: "Day Ahead Contingency Contracts",
        value: 526.84,
      },
      {
        month: "Mar-22",
        product: "Day Ahead Contingency Contracts",
        value: 377.17,
      },
      {
        month: "Apr-22",
        product: "Day Ahead Contingency Contracts",
        value: 762.1,
      },
      {
        month: "May-22",
        product: "Day Ahead Contingency Contracts",
        value: 334.56,
      },
      {
        month: "Jun-22",
        product: "Day Ahead Contingency Contracts",
        value: 724.6,
      },
      {
        month: "Jul-22",
        product: "Day Ahead Contingency Contracts",
        value: 527.14,
      },
      {
        month: "Aug-22",
        product: "Day Ahead Contingency Contracts",
        value: 477.76,
      },
      {
        month: "Sep-22",
        product: "Day Ahead Contingency Contracts",
        value: 473.27,
      },
      {
        month: "Oct-22",
        product: "Day Ahead Contingency Contracts",
        value: 294.25,
      },
      {
        month: "Nov-22",
        product: "Day Ahead Contingency Contracts",
        value: 170.22,
      },
      {
        month: "Dec-22",
        product: "Day Ahead Contingency Contracts",
        value: 263.32,
      },
      {
        month: "Jan-23",
        product: "Day Ahead Contingency Contracts",
        value: 522.3790124999994,
      },
      {
        month: "Feb-23",
        product: "Day Ahead Contingency Contracts",
        value: 554.7620075000004,
      },
      {
        month: "Mar-23",
        product: "Day Ahead Contingency Contracts",
        value: 514.3666100000003,
      },
      {
        month: "Apr-23",
        product: "Day Ahead Contingency Contracts",
        value: 456.2286124999996,
      },
      {
        month: "May-23",
        product: "Day Ahead Contingency Contracts",
        value: 362.6183099999988,
      },
      {
        month: "Jun-23",
        product: "Day Ahead Contingency Contracts",
        value: 568.5862679999988,
      },
      {
        month: "Jul-23",
        product: "Day Ahead Contingency Contracts",
        value: 368.253535,
      },
      {
        month: "Aug-23",
        product: "Day Ahead Contingency Contracts",
        value: 806.6119290000084,
      },
      {
        month: "Sep-23",
        product: "Day Ahead Contingency Contracts",
        value: 524.9293449999982,
      },
      {
        month: "Jan-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Daily Contracts",
        value: 19.2,
      },
      {
        month: "Jun-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Daily Contracts",
        value: 222.0,
      },
      {
        month: "Dec-22",
        product: "Daily Contracts",
        value: 245.74,
      },
      {
        month: "Jan-23",
        product: "Daily Contracts",
        value: 100.8,
      },
      {
        month: "Feb-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Daily Contracts",
        value: 51.6,
      },
      {
        month: "May-23",
        product: "Daily Contracts",
        value: 59.40000000000001,
      },
      {
        month: "Jun-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Daily Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Daily Contracts",
        value: 0.5599999999999999,
      },
      {
        month: "Sep-23",
        product: "Daily Contracts",
        value: 434.26931749999943,
      },
      {
        month: "Jan-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Weekly Contracts",
        value: 7.2,
      },
      {
        month: "Jun-17",
        product: "Weekly Contracts",
        value: 9.6,
      },
      {
        month: "Jul-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Weekly Contracts",
        value: 8.4,
      },
      {
        month: "Jan-18",
        product: "Weekly Contracts",
        value: 21.6,
      },
      {
        month: "Feb-18",
        product: "Weekly Contracts",
        value: 112.8,
      },
      {
        month: "Mar-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Weekly Contracts",
        value: 50.4,
      },
      {
        month: "May-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Weekly Contracts",
        value: 14.28,
      },
      {
        month: "Nov-18",
        product: "Weekly Contracts",
        value: 42.0,
      },
      {
        month: "Dec-18",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Weekly Contracts",
        value: 136.92,
      },
      {
        month: "Apr-19",
        product: "Weekly Contracts",
        value: 158.31,
      },
      {
        month: "May-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Weekly Contracts",
        value: 226.8,
      },
      {
        month: "Sep-19",
        product: "Weekly Contracts",
        value: 257.29,
      },
      {
        month: "Oct-19",
        product: "Weekly Contracts",
        value: 202.11,
      },
      {
        month: "Nov-19",
        product: "Weekly Contracts",
        value: 54.0,
      },
      {
        month: "Dec-19",
        product: "Weekly Contracts",
        value: 0.2,
      },
      {
        month: "Jan-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Weekly Contracts",
        value: 98.4,
      },
      {
        month: "Dec-22",
        product: "Weekly Contracts",
        value: 36.0,
      },
      {
        month: "Jan-23",
        product: "Weekly Contracts",
        value: 16.8,
      },
      {
        month: "Feb-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Weekly Contracts",
        value: 25.199999999999996,
      },
      {
        month: "May-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Weekly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Weekly Contracts",
        value: 105.86641249999997,
      },
      {
        month: "Sep-23",
        product: "Weekly Contracts",
        value: 135.95143000000007,
      },
      {
        month: "Jan-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Monthly Contracts",
        value: 0.0,
      },
      {
        month: "Jan-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Any Day Contracts",
        value: 29.66,
      },
      {
        month: "Oct-17",
        product: "Any Day Contracts",
        value: 157.69,
      },
      {
        month: "Nov-17",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Any Day Contracts",
        value: 4.32,
      },
      {
        month: "Jan-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Any Day Contracts",
        value: 46.8,
      },
      {
        month: "Apr-18",
        product: "Any Day Contracts",
        value: 83.92,
      },
      {
        month: "May-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Any Day Contracts",
        value: 16.8,
      },
      {
        month: "Oct-18",
        product: "Any Day Contracts",
        value: 42.0,
      },
      {
        month: "Nov-18",
        product: "Any Day Contracts",
        value: 14.4,
      },
      {
        month: "Dec-18",
        product: "Any Day Contracts",
        value: 5.76,
      },
      {
        month: "Jan-19",
        product: "Any Day Contracts",
        value: 10.68,
      },
      {
        month: "Feb-19",
        product: "Any Day Contracts",
        value: 61.33,
      },
      {
        month: "Mar-19",
        product: "Any Day Contracts",
        value: 225.74,
      },
      {
        month: "Apr-19",
        product: "Any Day Contracts",
        value: 44.91,
      },
      {
        month: "May-19",
        product: "Any Day Contracts",
        value: 70.09,
      },
      {
        month: "Jun-19",
        product: "Any Day Contracts",
        value: 22.52,
      },
      {
        month: "Jul-19",
        product: "Any Day Contracts",
        value: 66.41,
      },
      {
        month: "Aug-19",
        product: "Any Day Contracts",
        value: 105.6,
      },
      {
        month: "Sep-19",
        product: "Any Day Contracts",
        value: 68.93,
      },
      {
        month: "Oct-19",
        product: "Any Day Contracts",
        value: 199.09,
      },
      {
        month: "Nov-19",
        product: "Any Day Contracts",
        value: 36.75,
      },
      {
        month: "Dec-19",
        product: "Any Day Contracts",
        value: 123.15,
      },
      {
        month: "Jan-20",
        product: "Any Day Contracts",
        value: 15.62,
      },
      {
        month: "Feb-20",
        product: "Any Day Contracts",
        value: 10.46,
      },
      {
        month: "Mar-20",
        product: "Any Day Contracts",
        value: 7.91,
      },
      {
        month: "Apr-20",
        product: "Any Day Contracts",
        value: 182.35,
      },
      {
        month: "May-20",
        product: "Any Day Contracts",
        value: 248.5,
      },
      {
        month: "Jun-20",
        product: "Any Day Contracts",
        value: 57.64,
      },
      {
        month: "Jul-20",
        product: "Any Day Contracts",
        value: 8.48,
      },
      {
        month: "Aug-20",
        product: "Any Day Contracts",
        value: 302.45,
      },
      {
        month: "Sep-20",
        product: "Any Day Contracts",
        value: 446.08,
      },
      {
        month: "Oct-20",
        product: "Any Day Contracts",
        value: 770.46,
      },
      {
        month: "Nov-20",
        product: "Any Day Contracts",
        value: 852.25,
      },
      {
        month: "Dec-20",
        product: "Any Day Contracts",
        value: 911.03,
      },
      {
        month: "Jan-21",
        product: "Any Day Contracts",
        value: 592.75,
      },
      {
        month: "Feb-21",
        product: "Any Day Contracts",
        value: 465.83,
      },
      {
        month: "Mar-21",
        product: "Any Day Contracts",
        value: 376.47,
      },
      {
        month: "Apr-21",
        product: "Any Day Contracts",
        value: 482.55,
      },
      {
        month: "May-21",
        product: "Any Day Contracts",
        value: 350.18,
      },
      {
        month: "Jun-21",
        product: "Any Day Contracts",
        value: 240.61,
      },
      {
        month: "Jul-21",
        product: "Any Day Contracts",
        value: 213.62,
      },
      {
        month: "Aug-21",
        product: "Any Day Contracts",
        value: 123.11,
      },
      {
        month: "Sep-21",
        product: "Any Day Contracts",
        value: 104.16,
      },
      {
        month: "Oct-21",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Any Day Contracts",
        value: 33.6,
      },
      {
        month: "Dec-21",
        product: "Any Day Contracts",
        value: 3.6,
      },
      {
        month: "Jan-22",
        product: "Any Day Contracts",
        value: 58.8,
      },
      {
        month: "Feb-22",
        product: "Any Day Contracts",
        value: 206.68,
      },
      {
        month: "Mar-22",
        product: "Any Day Contracts",
        value: 143.59,
      },
      {
        month: "Apr-22",
        product: "Any Day Contracts",
        value: 955.49,
      },
      {
        month: "May-22",
        product: "Any Day Contracts",
        value: 809.95,
      },
      {
        month: "Jun-22",
        product: "Any Day Contracts",
        value: 31.2,
      },
      {
        month: "Jul-22",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Feb-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "May-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jun-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jul-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Aug-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Sep-23",
        product: "Any Day Contracts",
        value: 0.0,
      },
      {
        month: "Jan-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-17",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-18",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-19",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-20",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-21",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Feb-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "May-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jun-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jul-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Aug-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Sep-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Oct-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Nov-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Dec-22",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Jan-23",
        product: "Any Day Single Sided Contracts",
        value: 15.999999999999998,
      },
      {
        month: "Feb-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Mar-23",
        product: "Any Day Single Sided Contracts",
        value: 0.0,
      },
      {
        month: "Apr-23",
        product: "Any Day Single Sided Contracts",
        value: 34.5,
      },
      {
        month: "May-23",
        product: "Any Day Single Sided Contracts",
        value: 74.4,
      },
      {
        month: "Jun-23",
        product: "Any Day Single Sided Contracts",
        value: 172.79999999999995,
      },
      {
        month: "Jul-23",
        product: "Any Day Single Sided Contracts",
        value: 20.399999999999995,
      },
      {
        month: "Aug-23",
        product: "Any Day Single Sided Contracts",
        value: 180.92839999999998,
      },
      {
        month: "Sep-23",
        product: "Any Day Single Sided Contracts",
        value: 448.6333764999988,
      },
    ],
  },
  Traders: {},
};
